/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.3.0.0 (NJsonSchema v10.1.11.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { inject } from 'aurelia-framework';
import { HttpClient, RequestInit } from 'aurelia-fetch-client';

import * as moment from 'moment';

export interface IAOKRestApi {
    /**
     * UC-A020 AppUsage
     * @return OK
     */
    postAppUsageUsingPOST(): Promise<void>;
    /**
     * UC A-006 - Provide Configuration
     * @param request request
     * @return Get configuration success
     */
    requestConfigurationAppUsingGET(request: string): Promise<ConfigurationDTO[]>;
    /**
     * UC A-003 News Record
     * @param id id
     * @return Successfully listet News for current date)
     */
    getNewsRecordUsingGET(id: number): Promise<LoyaltyProgramNewsDTO>;
    /**
     * UC A-002 Maintain Rewards - getRewardById
     * @param id id
     * @return Reward query success
     */
    getRewardById(id: number): Promise<ExtendedRewardDTO>;
    /**
     * UC A-003 List Activity Prototypes
     * @param id id
     * @param year (optional) year
     * @return Successfully listet activity prototypes for current year
     */
    getActivityPrototypesUsingGET(id: number, year: number | null | undefined): Promise<LoyaltyProgramActivityPrototypeDTO[]>;
    /**
     * UC A-003 List FAQs
     * @param id id
     * @return Successfully listet FAQs for current date)
     */
    getFAQUsingGET(id: number): Promise<LoyaltyProgramFAQDTO[]>;
    /**
     * UC A-002 Maintain Rewards - listGroups
     * @param id id
     * @return Reward groups successfuly found
     */
    listGroups(id: number): Promise<RewardGroupDTO[]>;
    /**
     * UC A-003 List News
     * @param id id
     * @return Successfully listet News for current date)
     */
    getNewsUsingGET(id: number): Promise<LoyaltyProgramNewsDTO[]>;
    /**
     * UC A-004 Check KVNR
     * @param id id
     * @param kvnr kvnr
     * @return OK
     */
    checkKvnrUsingGET(id: number, kvnr: string): Promise<GetStatusResultDTO>;
    /**
     * UC A-004 updateCheckbookDelivery
     * @param id id
     * @param request request
     * @return Successfully found participant information)
     */
    updateCheckbookDeliveryUsingPOST(id: number, request: UpdateChequebookDeliveryDTO): Promise<void>;
    /**
     * UC A-004 Get Community Members
     * @param id id
     * @return Successfully found participant information)
     */
    getCommunityMemberUsingGET(id: number): Promise<CommunityMemberDTO>;
    /**
     * UC A-004 Get Community Members
     * @param id id
     * @return Successfully found participant information)
     */
    getCommunityMemberUsingPOST(id: number): Promise<CommunityMemberDTO>;
    /**
     * UC A-004 createOnlineAccess
     * @param id id
     * @param request request
     * @return OK
     */
    createOnlineAccessUsingPOST(id: number, request: CreateOnlineAccessRequestDTO): Promise<void>;
    /**
     * UC A-004 getMainInsured
     * @param id id
     * @return Successfully found participant information)
     */
    getMainInsuredUsingGET(id: number): Promise<PhvDTO>;
    /**
     * UC A-002 Maintain Rewards - listByLoyaltyProgramAndGroup
     * @param id id
     * @param groupKey groupKey
     * @param request request
     * @return Rewards successfuly found
     */
    listByLoyaltyProgramAndGroup(id: number, groupKey: string, request: QueryRewardsDTO): Promise<ExtendedRewardDTO[]>;
    /**
     * UC A-002 Maintain Rewards - listByLoyaltyProgram
     * @param id id
     * @param request request
     * @return Rewards successfuly found
     */
    listByLoyaltyProgram(id: number, request: QueryRewardsDTO): Promise<ExtendedRewardDTO[]>;
    /**
     * UC AA-002 Create Registration Request
     * @param pid pid
     * @param requestDTO requestDTO
     * @return Create participant registration form request success
     */
    createRegistrationRequestUsingPOST(pid: number, requestDTO: RegistrationFormRequestDTO): Promise<RegistrationFormResultDTO>;
    /**
     * UC A010 Redeem Chequebook Activity
     * @param membershipId (optional) Membership for which the redemption should be booked
     * @param activityId (optional) ID of the activity for which the redemption should be booked
     * @param activityRedemptionRequestDTO activityRedemptionRequestDTO
     * @return Redeem Success
     */
    redeemChequeBookActivityUsingPOST(membershipId: number | null | undefined, activityId: number | null | undefined, activityRedemptionRequestDTO: ActivityRedemptionRequestDTO): Promise<ActivityDTO>;
    /**
     * UC A-004 getMainInsured
     * @param membershipId membershipId
     * @param requestDownloadChequeBookDTO requestDownloadChequeBookDTO
     * @return Successfully found information and generated pdf
     */
    getChequeBookPdfUsingPOST(membershipId: number, requestDownloadChequeBookDTO: RequestDownloadChequeBookDTO): Promise<string>;
    /**
     * UC A013 Get chequebook
     * @param membershipId (optional) Membership for which the chequebook should be searched
     * @param year (optional) Year for which the chequebook should be searched
     * @param onlyRedeemableActivities (optional) Set to 'true' if you want to filter and activties should be evauluated. Default is false
     * @return Get Chequebook Success
     */
    getChequeBookAppUsingGET(membershipId: number | null | undefined, year: number | null | undefined, onlyRedeemableActivities: boolean | null | undefined): Promise<ChequeBookDTO>;
    /**
     * UC A-009 List Account Information - Get Account Balance
     * @param membershipid membershipid
     * @param body body
     * @return Account balance query success
     */
    getAccountBalanceAppUsingPOST(membershipid: number, body: GetAccountBalanceRequestDTO): Promise<AccountBalanceResponseDTO>;
    /**
     * UC A-009 List Account Information - Query Account Statements
     * @param membershipid membershipid
     * @param body body
     * @return Account statement query success
     */
    queryAccountStatementAppUsingPOST(membershipid: number, body: QueryAccountStatementRequestDTO): Promise<AccountStatementResponseDTO>;
    /**
     * UC A-009 List Account Information - Get Next Expiring Points
     * @param membershipid membershipid
     * @return Get next expiring points success
     */
    getNextExpiringPointsAppUsingGET(membershipid: number): Promise<ExpiringPointsResponseDTO>;
    /**
     * UC A-012 List orders
     * @param membershipid membershipid
     * @return Successful requested orders
     */
    listOrdersGET(membershipid: number): Promise<OrderDTO[]>;
    /**
     * UC A-012-01 Order rewards
     * @param membershipid membershipid
     * @param request request
     * @return Order created successful
     */
    createOrderRewardPOST(membershipid: number, request: OrderRewardRequestDTO): Promise<OrderDTO>;
    /**
     * UC A-012-03 Cancel order
     * @param membershipid membershipid
     * @param orderItemId orderItemId
     * @return Order canceled successful
     */
    cancelOrderPOST(membershipid: number, orderItemId: number): Promise<void>;
    /**
     * UC A-027-01 Query participant letter for subvention order
     * @param membershipid membershipid
     * @param orderId orderId
     * @return ParticipantLetter returned successfully
     */
    queryParticipantLetterForSubventionOrderUsingGET(membershipid: number, orderId: number): Promise<string>;
    /**
     * UC A-027-02 Query invoice documents for order
     * @param membershipid membershipid
     * @param orderId orderId
     * @return Initial invoice documents returned successfully
     */
    queryInvoiceDocumentsForOrderUsingGET(membershipid: number, orderId: number): Promise<RedeemSubventionRequestDTO>;
    /**
     * A 026 Query Participant Announcements
     * @param request request
     * @return Success
     */
    queryParticipantAnnouncementsUsingPOST(request: QueryParticipantAnouncementRequestDTO): Promise<QueryParticipantAnouncementResultDTO>;
    /**
     * UC AA-006 changePassword
     * @param changePasswordDTO changePasswordDTO
     * @return Created
     */
    changePasswordUsingPOST(changePasswordDTO: ChangePasswordDTO): Promise<void>;
    /**
     * UC AA001 manage tenants
     * @return get all tenants success
     */
    getAllTenantsUsingGET(): Promise<TenantDTO[]>;
    /**
     * UC AA001 manage tenants
     * @param type type
     * @return get tenants with specific program type success
     */
    getTenantsByTariffUsingGET(type: string): Promise<TenantDTO[]>;
    /**
     * A 025-01 Send Feedback via E-Mail
     * @param id id
     * @param feedback feedback
     * @return Send Feedback successful
     */
    sendFeedbackUsingPOST(id: number, feedback: FeedbackDTO): Promise<void>;
    /**
     * UC AA-003 Email Confirmation
     * @param lp lp
     * @param uuid uuid
     * @return Create participant registration form request success
     */
    confirmOptinTokenUsingGET(lp: number, uuid: string): Promise<void>;
}

@inject(String, HttpClient)
export class AOKRestApi implements IAOKRestApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "int-rest.aok-praemienprogramm.de/";
    }

    /**
     * UC-A020 AppUsage
     * @return OK
     */
    postAppUsageUsingPOST(): Promise<void> {
        let url_ = this.baseUrl + "/app/appUsage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostAppUsageUsingPOST(_response);
        });
    }

    protected processPostAppUsageUsingPOST(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("Participant was not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("Technical Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * UC A-006 - Provide Configuration
     * @param request request
     * @return Get configuration success
     */
    requestConfigurationAppUsingGET(request: string): Promise<ConfigurationDTO[]> {
        let url_ = this.baseUrl + "/app/configuration/enum/{request}";
        if (request === undefined || request === null)
            throw new Error("The parameter 'request' must be defined.");
        url_ = url_.replace("{request}", encodeURIComponent("" + request)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "*/*"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRequestConfigurationAppUsingGET(_response);
        });
    }

    protected processRequestConfigurationAppUsingGET(response: Response): Promise<ConfigurationDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ConfigurationDTO.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("Technischer Fehler", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfigurationDTO[]>(<any>null);
    }

    /**
     * UC A-003 News Record
     * @param id id
     * @return Successfully listet News for current date)
     */
    getNewsRecordUsingGET(id: number): Promise<LoyaltyProgramNewsDTO> {
        let url_ = this.baseUrl + "/app/loyaltyprogram/news/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNewsRecordUsingGET(_response);
        });
    }

    protected processGetNewsRecordUsingGET(response: Response): Promise<LoyaltyProgramNewsDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoyaltyProgramNewsDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("Record not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("Technical Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoyaltyProgramNewsDTO>(<any>null);
    }

    /**
     * UC A-002 Maintain Rewards - getRewardById
     * @param id id
     * @return Reward query success
     */
    getRewardById(id: number): Promise<ExtendedRewardDTO> {
        let url_ = this.baseUrl + "/app/loyaltyprogram/reward/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "*/*"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRewardById(_response);
        });
    }

    protected processGetRewardById(response: Response): Promise<ExtendedRewardDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExtendedRewardDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("Reward not found exception", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("Technischer Fehler", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExtendedRewardDTO>(<any>null);
    }

    /**
     * UC A-003 List Activity Prototypes
     * @param id id
     * @param year (optional) year
     * @return Successfully listet activity prototypes for current year
     */
    getActivityPrototypesUsingGET(id: number, year: number | null | undefined): Promise<LoyaltyProgramActivityPrototypeDTO[]> {
        let url_ = this.baseUrl + "/app/loyaltyprogram/{id}/activityprototypes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActivityPrototypesUsingGET(_response);
        });
    }

    protected processGetActivityPrototypesUsingGET(response: Response): Promise<LoyaltyProgramActivityPrototypeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LoyaltyProgramActivityPrototypeDTO.fromJS(item));
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("Bad Request -e.g. year request param is not current or last year ", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("No data found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("Technical Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoyaltyProgramActivityPrototypeDTO[]>(<any>null);
    }

    /**
     * UC A-003 List FAQs
     * @param id id
     * @return Successfully listet FAQs for current date)
     */
    getFAQUsingGET(id: number): Promise<LoyaltyProgramFAQDTO[]> {
        let url_ = this.baseUrl + "/app/loyaltyprogram/{id}/faq";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFAQUsingGET(_response);
        });
    }

    protected processGetFAQUsingGET(response: Response): Promise<LoyaltyProgramFAQDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LoyaltyProgramFAQDTO.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("No data found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("Technical Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoyaltyProgramFAQDTO[]>(<any>null);
    }

    /**
     * UC A-002 Maintain Rewards - listGroups
     * @param id id
     * @return Reward groups successfuly found
     */
    listGroups(id: number): Promise<RewardGroupDTO[]> {
        let url_ = this.baseUrl + "/app/loyaltyprogram/{id}/groups";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "*/*"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListGroups(_response);
        });
    }

    protected processListGroups(response: Response): Promise<RewardGroupDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RewardGroupDTO.fromJS(item));
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("No reward group found exception", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("Technischer Fehler", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RewardGroupDTO[]>(<any>null);
    }

    /**
     * UC A-003 List News
     * @param id id
     * @return Successfully listet News for current date)
     */
    getNewsUsingGET(id: number): Promise<LoyaltyProgramNewsDTO[]> {
        let url_ = this.baseUrl + "/app/loyaltyprogram/{id}/news";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNewsUsingGET(_response);
        });
    }

    protected processGetNewsUsingGET(response: Response): Promise<LoyaltyProgramNewsDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LoyaltyProgramNewsDTO.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("No data found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("Technical Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoyaltyProgramNewsDTO[]>(<any>null);
    }

    /**
     * UC A-004 Check KVNR
     * @param id id
     * @param kvnr kvnr
     * @return OK
     */
    checkKvnrUsingGET(id: number, kvnr: string): Promise<GetStatusResultDTO> {
        let url_ = this.baseUrl + "/app/loyaltyprogram/{id}/participant/checkkvnr/{kvnr}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (kvnr === undefined || kvnr === null)
            throw new Error("The parameter 'kvnr' must be defined.");
        url_ = url_.replace("{kvnr}", encodeURIComponent("" + kvnr)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "*/*"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckKvnrUsingGET(_response);
        });
    }

    protected processCheckKvnrUsingGET(response: Response): Promise<GetStatusResultDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStatusResultDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("ValidationException", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("No data found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("Technical Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetStatusResultDTO>(<any>null);
    }

    /**
     * UC A-004 updateCheckbookDelivery
     * @param id id
     * @param request request
     * @return Successfully found participant information)
     */
    updateCheckbookDeliveryUsingPOST(id: number, request: UpdateChequebookDeliveryDTO): Promise<void> {
        let url_ = this.baseUrl + "/app/loyaltyprogram/{id}/participant/chequebookdelivery";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCheckbookDeliveryUsingPOST(_response);
        });
    }

    protected processUpdateCheckbookDeliveryUsingPOST(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("ValidationException", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("No data found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ErrorDTO.fromJS(resultData409);
            return throwException("Sync In Process", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("Technical Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * UC A-004 Get Community Members
     * @param id id
     * @return Successfully found participant information)
     */
    getCommunityMemberUsingGET(id: number): Promise<CommunityMemberDTO> {
        let url_ = this.baseUrl + "/app/loyaltyprogram/{id}/participant/communitymember";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "*/*"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCommunityMemberUsingGET(_response);
        });
    }

    protected processGetCommunityMemberUsingGET(response: Response): Promise<CommunityMemberDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommunityMemberDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("No data found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("Technical Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommunityMemberDTO>(<any>null);
    }

    /**
     * UC A-004 Get Community Members
     * @param id id
     * @return Successfully found participant information)
     */
    getCommunityMemberUsingPOST(id: number): Promise<CommunityMemberDTO> {
        let url_ = this.baseUrl + "/app/loyaltyprogram/{id}/participant/communitymember";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "*/*"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCommunityMemberUsingPOST(_response);
        });
    }

    protected processGetCommunityMemberUsingPOST(response: Response): Promise<CommunityMemberDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommunityMemberDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            return throwException("Created", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("No data found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("Technical Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommunityMemberDTO>(<any>null);
    }

    /**
     * UC A-004 createOnlineAccess
     * @param id id
     * @param request request
     * @return OK
     */
    createOnlineAccessUsingPOST(id: number, request: CreateOnlineAccessRequestDTO): Promise<void> {
        let url_ = this.baseUrl + "/app/loyaltyprogram/{id}/participant/createonlineaccess";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateOnlineAccessUsingPOST(_response);
        });
    }

    protected processCreateOnlineAccessUsingPOST(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("ValidationException, ParticipantNotActiveException", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("No data found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ErrorDTO.fromJS(resultData409);
            return throwException("Sync In Process", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("Technical Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * UC A-004 getMainInsured
     * @param id id
     * @return Successfully found participant information)
     */
    getMainInsuredUsingGET(id: number): Promise<PhvDTO> {
        let url_ = this.baseUrl + "/app/loyaltyprogram/{id}/participant/main-insured";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "*/*"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMainInsuredUsingGET(_response);
        });
    }

    protected processGetMainInsuredUsingGET(response: Response): Promise<PhvDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhvDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("No data found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("Technical Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PhvDTO>(<any>null);
    }

    /**
     * UC A-002 Maintain Rewards - listByLoyaltyProgramAndGroup
     * @param id id
     * @param groupKey groupKey
     * @param request request
     * @return Rewards successfuly found
     */
    listByLoyaltyProgramAndGroup(id: number, groupKey: string, request: QueryRewardsDTO): Promise<ExtendedRewardDTO[]> {
        let url_ = this.baseUrl + "/app/loyaltyprogram/{id}/rewardsbygroup/{groupKey}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (groupKey === undefined || groupKey === null)
            throw new Error("The parameter 'groupKey' must be defined.");
        url_ = url_.replace("{groupKey}", encodeURIComponent("" + groupKey)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListByLoyaltyProgramAndGroup(_response);
        });
    }

    protected processListByLoyaltyProgramAndGroup(response: Response): Promise<ExtendedRewardDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ExtendedRewardDTO.fromJS(item));
            }
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            return throwException("Created", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("No reward group found exception", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("Technischer Fehler", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExtendedRewardDTO[]>(<any>null);
    }

    /**
     * UC A-002 Maintain Rewards - listByLoyaltyProgram
     * @param id id
     * @param request request
     * @return Rewards successfuly found
     */
    listByLoyaltyProgram(id: number, request: QueryRewardsDTO): Promise<ExtendedRewardDTO[]> {
        let url_ = this.baseUrl + "/app/loyaltyprogram/{id}/rewardsbyprogram";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListByLoyaltyProgram(_response);
        });
    }

    protected processListByLoyaltyProgram(response: Response): Promise<ExtendedRewardDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ExtendedRewardDTO.fromJS(item));
            }
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            return throwException("Created", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("No reward group found exception", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("Technischer Fehler", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExtendedRewardDTO[]>(<any>null);
    }

    /**
     * UC AA-002 Create Registration Request
     * @param pid pid
     * @param requestDTO requestDTO
     * @return Create participant registration form request success
     */
    createRegistrationRequestUsingPOST(pid: number, requestDTO: RegistrationFormRequestDTO): Promise<RegistrationFormResultDTO> {
        let url_ = this.baseUrl + "/app/loyaltyprogram/{pid}/registrationrequest/registrationform";
        if (pid === undefined || pid === null)
            throw new Error("The parameter 'pid' must be defined.");
        url_ = url_.replace("{pid}", encodeURIComponent("" + pid)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateRegistrationRequestUsingPOST(_response);
        });
    }

    protected processCreateRegistrationRequestUsingPOST(response: Response): Promise<RegistrationFormResultDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationFormResultDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            return throwException("Created", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("Loyalty program was not found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ErrorDTO.fromJS(resultData409);
            return throwException("Participant already registered", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("Technical error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = ErrorDTO.fromJS(resultData503);
            return throwException("Address validation unavailable", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationFormResultDTO>(<any>null);
    }

    /**
     * UC A010 Redeem Chequebook Activity
     * @param membershipId (optional) Membership for which the redemption should be booked
     * @param activityId (optional) ID of the activity for which the redemption should be booked
     * @param activityRedemptionRequestDTO activityRedemptionRequestDTO
     * @return Redeem Success
     */
    redeemChequeBookActivityUsingPOST(membershipId: number | null | undefined, activityId: number | null | undefined, activityRedemptionRequestDTO: ActivityRedemptionRequestDTO): Promise<ActivityDTO> {
        let url_ = this.baseUrl + "/app/memberships/{membershipId}/chequebooks/activities/{activityId}";
        if (membershipId !== null && membershipId !== undefined)
        url_ = url_.replace("{membershipId}", encodeURIComponent("" + membershipId)); 
        else
            url_ = url_.replace("/{membershipId}", "");
        if (activityId !== null && activityId !== undefined)
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId)); 
        else
            url_ = url_.replace("/{activityId}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activityRedemptionRequestDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRedeemChequeBookActivityUsingPOST(_response);
        });
    }

    protected processRedeemChequeBookActivityUsingPOST(response: Response): Promise<ActivityDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            return throwException("Created", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("Validation exception e.g. DTO input does not match to the configured activity prototype", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorDTO.fromJS(resultData403);
            return throwException("File type invalid, file too large, already an open redemption request or redemption already booked", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("Membership or Activity not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("Technical Error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = ErrorDTO.fromJS(resultData503);
            return throwException("Archifant is not reachable", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityDTO>(<any>null);
    }

    /**
     * UC A-004 getMainInsured
     * @param membershipId membershipId
     * @param requestDownloadChequeBookDTO requestDownloadChequeBookDTO
     * @return Successfully found information and generated pdf
     */
    getChequeBookPdfUsingPOST(membershipId: number, requestDownloadChequeBookDTO: RequestDownloadChequeBookDTO): Promise<string> {
        let url_ = this.baseUrl + "/app/memberships/{membershipId}/chequebooks/download";
        if (membershipId === undefined || membershipId === null)
            throw new Error("The parameter 'membershipId' must be defined.");
        url_ = url_.replace("{membershipId}", encodeURIComponent("" + membershipId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDownloadChequeBookDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/pdf"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetChequeBookPdfUsingPOST(_response);
        });
    }

    protected processGetChequeBookPdfUsingPOST(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 !== undefined ? resultData201 : <any>null;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("Bad Request, e.g. Activity Already Redeemed Exception", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorDTO.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("No data found (Participant/Membership/Activity)", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("Technical Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * UC A013 Get chequebook
     * @param membershipId (optional) Membership for which the chequebook should be searched
     * @param year (optional) Year for which the chequebook should be searched
     * @param onlyRedeemableActivities (optional) Set to 'true' if you want to filter and activties should be evauluated. Default is false
     * @return Get Chequebook Success
     */
    getChequeBookAppUsingGET(membershipId: number | null | undefined, year: number | null | undefined, onlyRedeemableActivities: boolean | null | undefined): Promise<ChequeBookDTO> {
        let url_ = this.baseUrl + "/app/memberships/{membershipId}/chequebooks/{year}?";
        if (membershipId !== null && membershipId !== undefined)
        url_ = url_.replace("{membershipId}", encodeURIComponent("" + membershipId)); 
        else
            url_ = url_.replace("/{membershipId}", "");
        if (year !== null && year !== undefined)
        url_ = url_.replace("{year}", encodeURIComponent("" + year)); 
        else
            url_ = url_.replace("/{year}", "");
        if (onlyRedeemableActivities !== undefined)
            url_ += "onlyRedeemableActivities=" + encodeURIComponent("" + onlyRedeemableActivities) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetChequeBookAppUsingGET(_response);
        });
    }

    protected processGetChequeBookAppUsingGET(response: Response): Promise<ChequeBookDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChequeBookDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("Membership or Chequebook not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("Technical Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChequeBookDTO>(<any>null);
    }

    /**
     * UC A-009 List Account Information - Get Account Balance
     * @param membershipid membershipid
     * @param body body
     * @return Account balance query success
     */
    getAccountBalanceAppUsingPOST(membershipid: number, body: GetAccountBalanceRequestDTO): Promise<AccountBalanceResponseDTO> {
        let url_ = this.baseUrl + "/app/memberships/{membershipid}/accountbalance";
        if (membershipid === undefined || membershipid === null)
            throw new Error("The parameter 'membershipid' must be defined.");
        url_ = url_.replace("{membershipid}", encodeURIComponent("" + membershipid)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAccountBalanceAppUsingPOST(_response);
        });
    }

    protected processGetAccountBalanceAppUsingPOST(response: Response): Promise<AccountBalanceResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountBalanceResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            return throwException("Created", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("Membership or Participant not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("Technischer Fehler", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountBalanceResponseDTO>(<any>null);
    }

    /**
     * UC A-009 List Account Information - Query Account Statements
     * @param membershipid membershipid
     * @param body body
     * @return Account statement query success
     */
    queryAccountStatementAppUsingPOST(membershipid: number, body: QueryAccountStatementRequestDTO): Promise<AccountStatementResponseDTO> {
        let url_ = this.baseUrl + "/app/memberships/{membershipid}/accountstatement";
        if (membershipid === undefined || membershipid === null)
            throw new Error("The parameter 'membershipid' must be defined.");
        url_ = url_.replace("{membershipid}", encodeURIComponent("" + membershipid)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processQueryAccountStatementAppUsingPOST(_response);
        });
    }

    protected processQueryAccountStatementAppUsingPOST(response: Response): Promise<AccountStatementResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountStatementResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            return throwException("Created", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("Membership or Participant not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("Technischer Fehler", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountStatementResponseDTO>(<any>null);
    }

    /**
     * UC A-009 List Account Information - Get Next Expiring Points
     * @param membershipid membershipid
     * @return Get next expiring points success
     */
    getNextExpiringPointsAppUsingGET(membershipid: number): Promise<ExpiringPointsResponseDTO> {
        let url_ = this.baseUrl + "/app/memberships/{membershipid}/expiringpoints";
        if (membershipid === undefined || membershipid === null)
            throw new Error("The parameter 'membershipid' must be defined.");
        url_ = url_.replace("{membershipid}", encodeURIComponent("" + membershipid)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "*/*"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNextExpiringPointsAppUsingGET(_response);
        });
    }

    protected processGetNextExpiringPointsAppUsingGET(response: Response): Promise<ExpiringPointsResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpiringPointsResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("Membership or Participant not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("Technischer Fehler", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpiringPointsResponseDTO>(<any>null);
    }

    /**
     * UC A-012 List orders
     * @param membershipid membershipid
     * @return Successful requested orders
     */
    listOrdersGET(membershipid: number): Promise<OrderDTO[]> {
        let url_ = this.baseUrl + "/app/memberships/{membershipid}/orders";
        if (membershipid === undefined || membershipid === null)
            throw new Error("The parameter 'membershipid' must be defined.");
        url_ = url_.replace("{membershipid}", encodeURIComponent("" + membershipid)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "*/*"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListOrdersGET(_response);
        });
    }

    protected processListOrdersGET(response: Response): Promise<OrderDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderDTO.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("Participant or membership not found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderDTO[]>(<any>null);
    }

    /**
     * UC A-012-01 Order rewards
     * @param membershipid membershipid
     * @param request request
     * @return Order created successful
     */
    createOrderRewardPOST(membershipid: number, request: OrderRewardRequestDTO): Promise<OrderDTO> {
        let url_ = this.baseUrl + "/app/memberships/{membershipid}/orders";
        if (membershipid === undefined || membershipid === null)
            throw new Error("The parameter 'membershipid' must be defined.");
        url_ = url_.replace("{membershipid}", encodeURIComponent("" + membershipid)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateOrderRewardPOST(_response);
        });
    }

    protected processCreateOrderRewardPOST(response: Response): Promise<OrderDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            return throwException("Created", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("Participant, Reward or membership not found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ErrorDTO.fromJS(resultData409);
            return throwException("Duplicate insurant on request master data", status, _responseText, _headers, result409);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            let resultData423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result423 = ErrorDTO.fromJS(resultData423);
            return throwException("Account is locked", status, _responseText, _headers, result423);
            });
        } else if (status === 460) {
            return response.text().then((_responseText) => {
            let result460: any = null;
            let resultData460 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result460 = ErrorDTO.fromJS(resultData460);
            return throwException("Insurance not started on request master data", status, _responseText, _headers, result460);
            });
        } else if (status === 461) {
            return response.text().then((_responseText) => {
            let result461: any = null;
            let resultData461 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result461 = ErrorDTO.fromJS(resultData461);
            return throwException("Insurance already ended on request master data", status, _responseText, _headers, result461);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("General error on request master data", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = ErrorDTO.fromJS(resultData503);
            return throwException("Web service is not available", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderDTO>(<any>null);
    }

    /**
     * UC A-012-03 Cancel order
     * @param membershipid membershipid
     * @param orderItemId orderItemId
     * @return Order canceled successful
     */
    cancelOrderPOST(membershipid: number, orderItemId: number): Promise<void> {
        let url_ = this.baseUrl + "/app/memberships/{membershipid}/orders/items/{orderItemId}/cancel";
        if (membershipid === undefined || membershipid === null)
            throw new Error("The parameter 'membershipid' must be defined.");
        url_ = url_.replace("{membershipid}", encodeURIComponent("" + membershipid)); 
        if (orderItemId === undefined || orderItemId === null)
            throw new Error("The parameter 'orderItemId' must be defined.");
        url_ = url_.replace("{orderItemId}", encodeURIComponent("" + orderItemId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCancelOrderPOST(_response);
        });
    }

    protected processCancelOrderPOST(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("Participant, Membership or OrderItem not found", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            let resultData423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result423 = ErrorDTO.fromJS(resultData423);
            return throwException("Account is locked", status, _responseText, _headers, result423);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * UC A-027-01 Query participant letter for subvention order
     * @param membershipid membershipid
     * @param orderId orderId
     * @return ParticipantLetter returned successfully
     */
    queryParticipantLetterForSubventionOrderUsingGET(membershipid: number, orderId: number): Promise<string> {
        let url_ = this.baseUrl + "/app/memberships/{membershipid}/orders/{orderId}/document";
        if (membershipid === undefined || membershipid === null)
            throw new Error("The parameter 'membershipid' must be defined.");
        url_ = url_.replace("{membershipid}", encodeURIComponent("" + membershipid)); 
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "*/*"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processQueryParticipantLetterForSubventionOrderUsingGET(_response);
        });
    }

    protected processQueryParticipantLetterForSubventionOrderUsingGET(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("Participant, Membership or OrderItem not found", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            let resultData423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result423 = ErrorDTO.fromJS(resultData423);
            return throwException("Account is locked", status, _responseText, _headers, result423);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * UC A-027-02 Query invoice documents for order
     * @param membershipid membershipid
     * @param orderId orderId
     * @return Initial invoice documents returned successfully
     */
    queryInvoiceDocumentsForOrderUsingGET(membershipid: number, orderId: number): Promise<RedeemSubventionRequestDTO> {
        let url_ = this.baseUrl + "/app/memberships/{membershipid}/orders/{orderId}/initial-invoice";
        if (membershipid === undefined || membershipid === null)
            throw new Error("The parameter 'membershipid' must be defined.");
        url_ = url_.replace("{membershipid}", encodeURIComponent("" + membershipid)); 
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "*/*"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processQueryInvoiceDocumentsForOrderUsingGET(_response);
        });
    }

    protected processQueryInvoiceDocumentsForOrderUsingGET(response: Response): Promise<RedeemSubventionRequestDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RedeemSubventionRequestDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("Participant, Membership or OrderItem not found", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            let resultData423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result423 = ErrorDTO.fromJS(resultData423);
            return throwException("Account is locked", status, _responseText, _headers, result423);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RedeemSubventionRequestDTO>(<any>null);
    }

    /**
     * A 026 Query Participant Announcements
     * @param request request
     * @return Success
     */
    queryParticipantAnnouncementsUsingPOST(request: QueryParticipantAnouncementRequestDTO): Promise<QueryParticipantAnouncementResultDTO> {
        let url_ = this.baseUrl + "/app/participants/announcements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processQueryParticipantAnnouncementsUsingPOST(_response);
        });
    }

    protected processQueryParticipantAnnouncementsUsingPOST(response: Response): Promise<QueryParticipantAnouncementResultDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryParticipantAnouncementResultDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            return throwException("Created", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("Technical Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryParticipantAnouncementResultDTO>(<any>null);
    }

    /**
     * UC AA-006 changePassword
     * @param changePasswordDTO changePasswordDTO
     * @return Created
     */
    changePasswordUsingPOST(changePasswordDTO: ChangePasswordDTO): Promise<void> {
        let url_ = this.baseUrl + "/app/participants/change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changePasswordDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangePasswordUsingPOST(_response);
        });
    }

    protected processChangePasswordUsingPOST(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result204 = CommunityMemberDTO.fromJS(resultData204);
            return throwException("Successfully updated password)", status, _responseText, _headers, result204);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("e.g. IncorrectPasswordException, CouldNotChangePasswordException", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("No data found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("Technical Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * UC AA001 manage tenants
     * @return get all tenants success
     */
    getAllTenantsUsingGET(): Promise<TenantDTO[]> {
        let url_ = this.baseUrl + "/app/tenants/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "*/*"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllTenantsUsingGET(_response);
        });
    }

    protected processGetAllTenantsUsingGET(response: Response): Promise<TenantDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TenantDTO.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("Technical Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantDTO[]>(<any>null);
    }

    /**
     * UC AA001 manage tenants
     * @param type type
     * @return get tenants with specific program type success
     */
    getTenantsByTariffUsingGET(type: string): Promise<TenantDTO[]> {
        let url_ = this.baseUrl + "/app/tenants/by-program-type/{type}";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "*/*"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTenantsByTariffUsingGET(_response);
        });
    }

    protected processGetTenantsByTariffUsingGET(response: Response): Promise<TenantDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TenantDTO.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDTO.fromJS(resultData401);
            return throwException("Unauthorized access", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("No Tenant found for this type", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("Technical Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantDTO[]>(<any>null);
    }

    /**
     * A 025-01 Send Feedback via E-Mail
     * @param id id
     * @param feedback feedback
     * @return Send Feedback successful
     */
    sendFeedbackUsingPOST(id: number, feedback: FeedbackDTO): Promise<void> {
        let url_ = this.baseUrl + "/feedback/loyaltyprogram/{id}/feedback";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(feedback);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendFeedbackUsingPOST(_response);
        });
    }

    protected processSendFeedbackUsingPOST(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("Tenant or Loyaltyprogram not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("Technical Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * UC AA-003 Email Confirmation
     * @param lp lp
     * @param uuid uuid
     * @return Create participant registration form request success
     */
    confirmOptinTokenUsingGET(lp: number, uuid: string): Promise<void> {
        let url_ = this.baseUrl + "/registration/loyaltyprogram/{lp}/confirm-email/{uuid}";
        if (lp === undefined || lp === null)
            throw new Error("The parameter 'lp' must be defined.");
        url_ = url_.replace("{lp}", encodeURIComponent("" + lp)); 
        if (uuid === undefined || uuid === null)
            throw new Error("The parameter 'uuid' must be defined.");
        url_ = url_.replace("{uuid}", encodeURIComponent("" + uuid)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfirmOptinTokenUsingGET(_response);
        });
    }

    protected processConfirmOptinTokenUsingGET(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("Bad Request e.g. OptInToken is expired", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDTO.fromJS(resultData404);
            return throwException("NotFound OptInToken for given uuid or Participant, LoyaltyProgram...", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ErrorDTO.fromJS(resultData409);
            return throwException("OptInToken already Confirmed", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDTO.fromJS(resultData500);
            return throwException("Technical error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

/** Result object for get account balance in UC S-009 */
export class AccountBalanceResponseDTO implements IAccountBalanceResponseDTO {
    accountId?: number | undefined;
    activityLevel?: ActivityLevelDTO | undefined;
    collectedPoints?: number | undefined;
    endBalance?: number | undefined;
    endDate?: moment.Moment | undefined;
    remainingPoints?: number | undefined;
    startBalance?: number | undefined;
    startDate?: moment.Moment | undefined;

    constructor(data?: IAccountBalanceResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.activityLevel = _data["activityLevel"] ? ActivityLevelDTO.fromJS(_data["activityLevel"]) : <any>undefined;
            this.collectedPoints = _data["collectedPoints"];
            this.endBalance = _data["endBalance"];
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.remainingPoints = _data["remainingPoints"];
            this.startBalance = _data["startBalance"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AccountBalanceResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccountBalanceResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["activityLevel"] = this.activityLevel ? this.activityLevel.toJSON() : <any>undefined;
        data["collectedPoints"] = this.collectedPoints;
        data["endBalance"] = this.endBalance;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["remainingPoints"] = this.remainingPoints;
        data["startBalance"] = this.startBalance;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        return data; 
    }
}

/** Result object for get account balance in UC S-009 */
export interface IAccountBalanceResponseDTO {
    accountId?: number | undefined;
    activityLevel?: ActivityLevelDTO | undefined;
    collectedPoints?: number | undefined;
    endBalance?: number | undefined;
    endDate?: moment.Moment | undefined;
    remainingPoints?: number | undefined;
    startBalance?: number | undefined;
    startDate?: moment.Moment | undefined;
}

/** Result object for query account statement UC S-009 */
export class AccountStatementResponseDTO implements IAccountStatementResponseDTO {
    /** Account ID */
    accountId?: number | undefined;
    /** Current page index for this result */
    pageNumber?: number | undefined;
    /** Page size used to create this result */
    pageResultQuantity?: number | undefined;
    /** The list of postings only for this page */
    postings?: PostingDTO[] | undefined;
    /** End date of Statements Query Result */
    statementsEndDate?: moment.Moment | undefined;
    /** Start date of Statements Query Result */
    statementsStartDate?: moment.Moment | undefined;
    /** The total count of possible results without paging */
    totalResultQuantity?: number | undefined;

    constructor(data?: IAccountStatementResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.pageNumber = _data["pageNumber"];
            this.pageResultQuantity = _data["pageResultQuantity"];
            if (Array.isArray(_data["postings"])) {
                this.postings = [] as any;
                for (let item of _data["postings"])
                    this.postings.push(PostingDTO.fromJS(item));
            }
            this.statementsEndDate = _data["statementsEndDate"] ? moment(_data["statementsEndDate"].toString()) : <any>undefined;
            this.statementsStartDate = _data["statementsStartDate"] ? moment(_data["statementsStartDate"].toString()) : <any>undefined;
            this.totalResultQuantity = _data["totalResultQuantity"];
        }
    }

    static fromJS(data: any): AccountStatementResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccountStatementResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["pageNumber"] = this.pageNumber;
        data["pageResultQuantity"] = this.pageResultQuantity;
        if (Array.isArray(this.postings)) {
            data["postings"] = [];
            for (let item of this.postings)
                data["postings"].push(item.toJSON());
        }
        data["statementsEndDate"] = this.statementsEndDate ? this.statementsEndDate.toISOString() : <any>undefined;
        data["statementsStartDate"] = this.statementsStartDate ? this.statementsStartDate.toISOString() : <any>undefined;
        data["totalResultQuantity"] = this.totalResultQuantity;
        return data; 
    }
}

/** Result object for query account statement UC S-009 */
export interface IAccountStatementResponseDTO {
    /** Account ID */
    accountId?: number | undefined;
    /** Current page index for this result */
    pageNumber?: number | undefined;
    /** Page size used to create this result */
    pageResultQuantity?: number | undefined;
    /** The list of postings only for this page */
    postings?: PostingDTO[] | undefined;
    /** End date of Statements Query Result */
    statementsEndDate?: moment.Moment | undefined;
    /** Start date of Statements Query Result */
    statementsStartDate?: moment.Moment | undefined;
    /** The total count of possible results without paging */
    totalResultQuantity?: number | undefined;
}

export class ActivityDTO implements IActivityDTO {
    /** Date when the activity was performed */
    activityDate?: moment.Moment | undefined;
    /** The category of the activity */
    category?: string | undefined;
    /** Category extern of the activity */
    categoryExtern?: string | undefined;
    /** Cheque Document Details */
    chequeDocumentDetails?: ChequeDocumentDetailsDTO | undefined;
    /** true if it's possible to give a direct Reward */
    directRewardEnabled?: boolean | undefined;
    /** true if the activity can be redeemed multiple times */
    ensureRedeemableActivityInChequebook?: boolean | undefined;
    /** Technical ID of the activity */
    id?: number | undefined;
    /** Key for the activity */
    key?: string | undefined;
    /** Details for multiple redeemable activities. Is only filled if a redeemed activity was posted. */
    multipleRedeemableActivityDetail?: MultipleRedeemableActivityDetailDTO | undefined;
    /** The name of the activity */
    name?: string | undefined;
    /** Name extern of the activity */
    nameExtern?: string | undefined;
    /** Technical ID of the order a direct reward was applied */
    orderId?: number | undefined;
    /** Technical ID of the activity prototype */
    prototypeId?: number | undefined;
    /** Date when the redemption was performed */
    redemptionDate?: moment.Moment | undefined;
    /** The requests in which the activity were submitted */
    request?: RedemptionRequestDTO[] | undefined;
    /** Value of the activity */
    value?: number | undefined;

    constructor(data?: IActivityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityDate = _data["activityDate"] ? moment(_data["activityDate"].toString()) : <any>undefined;
            this.category = _data["category"];
            this.categoryExtern = _data["categoryExtern"];
            this.chequeDocumentDetails = _data["chequeDocumentDetails"] ? ChequeDocumentDetailsDTO.fromJS(_data["chequeDocumentDetails"]) : <any>undefined;
            this.directRewardEnabled = _data["directRewardEnabled"];
            this.ensureRedeemableActivityInChequebook = _data["ensureRedeemableActivityInChequebook"];
            this.id = _data["id"];
            this.key = _data["key"];
            this.multipleRedeemableActivityDetail = _data["multipleRedeemableActivityDetail"] ? MultipleRedeemableActivityDetailDTO.fromJS(_data["multipleRedeemableActivityDetail"]) : <any>undefined;
            this.name = _data["name"];
            this.nameExtern = _data["nameExtern"];
            this.orderId = _data["orderId"];
            this.prototypeId = _data["prototypeId"];
            this.redemptionDate = _data["redemptionDate"] ? moment(_data["redemptionDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["request"])) {
                this.request = [] as any;
                for (let item of _data["request"])
                    this.request.push(RedemptionRequestDTO.fromJS(item));
            }
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ActivityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityDate"] = this.activityDate ? this.activityDate.toISOString() : <any>undefined;
        data["category"] = this.category;
        data["categoryExtern"] = this.categoryExtern;
        data["chequeDocumentDetails"] = this.chequeDocumentDetails ? this.chequeDocumentDetails.toJSON() : <any>undefined;
        data["directRewardEnabled"] = this.directRewardEnabled;
        data["ensureRedeemableActivityInChequebook"] = this.ensureRedeemableActivityInChequebook;
        data["id"] = this.id;
        data["key"] = this.key;
        data["multipleRedeemableActivityDetail"] = this.multipleRedeemableActivityDetail ? this.multipleRedeemableActivityDetail.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["nameExtern"] = this.nameExtern;
        data["orderId"] = this.orderId;
        data["prototypeId"] = this.prototypeId;
        data["redemptionDate"] = this.redemptionDate ? this.redemptionDate.toISOString() : <any>undefined;
        if (Array.isArray(this.request)) {
            data["request"] = [];
            for (let item of this.request)
                data["request"].push(item.toJSON());
        }
        data["value"] = this.value;
        return data; 
    }
}

export interface IActivityDTO {
    /** Date when the activity was performed */
    activityDate?: moment.Moment | undefined;
    /** The category of the activity */
    category?: string | undefined;
    /** Category extern of the activity */
    categoryExtern?: string | undefined;
    /** Cheque Document Details */
    chequeDocumentDetails?: ChequeDocumentDetailsDTO | undefined;
    /** true if it's possible to give a direct Reward */
    directRewardEnabled?: boolean | undefined;
    /** true if the activity can be redeemed multiple times */
    ensureRedeemableActivityInChequebook?: boolean | undefined;
    /** Technical ID of the activity */
    id?: number | undefined;
    /** Key for the activity */
    key?: string | undefined;
    /** Details for multiple redeemable activities. Is only filled if a redeemed activity was posted. */
    multipleRedeemableActivityDetail?: MultipleRedeemableActivityDetailDTO | undefined;
    /** The name of the activity */
    name?: string | undefined;
    /** Name extern of the activity */
    nameExtern?: string | undefined;
    /** Technical ID of the order a direct reward was applied */
    orderId?: number | undefined;
    /** Technical ID of the activity prototype */
    prototypeId?: number | undefined;
    /** Date when the redemption was performed */
    redemptionDate?: moment.Moment | undefined;
    /** The requests in which the activity were submitted */
    request?: RedemptionRequestDTO[] | undefined;
    /** Value of the activity */
    value?: number | undefined;
}

/** Activity Level DTO for App. */
export class ActivityLevelDTO implements IActivityLevelDTO {
    /** Minimum balance of the Activity level. */
    minimumBalance?: number | undefined;
    /** Name of the Activity level. */
    name?: string | undefined;

    constructor(data?: IActivityLevelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minimumBalance = _data["minimumBalance"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ActivityLevelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLevelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minimumBalance"] = this.minimumBalance;
        data["name"] = this.name;
        return data; 
    }
}

/** Activity Level DTO for App. */
export interface IActivityLevelDTO {
    /** Minimum balance of the Activity level. */
    minimumBalance?: number | undefined;
    /** Name of the Activity level. */
    name?: string | undefined;
}

export class ActivityRedemptionRequestDTO implements IActivityRedemptionRequestDTO {
    /** activity date */
    activityDate?: moment.Moment | undefined;
    /** set if it's a multiple reedamable activity */
    detail?: MultipleRedeemableActivityDetailDTO | undefined;
    /** set for direct award */
    directRewardRequest?: DirectRewardRequestDTO | undefined;
    fileAttachments?: FileAttachmentDTO[] | undefined;

    constructor(data?: IActivityRedemptionRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityDate = _data["activityDate"] ? moment(_data["activityDate"].toString()) : <any>undefined;
            this.detail = _data["detail"] ? MultipleRedeemableActivityDetailDTO.fromJS(_data["detail"]) : <any>undefined;
            this.directRewardRequest = _data["directRewardRequest"] ? DirectRewardRequestDTO.fromJS(_data["directRewardRequest"]) : <any>undefined;
            if (Array.isArray(_data["fileAttachments"])) {
                this.fileAttachments = [] as any;
                for (let item of _data["fileAttachments"])
                    this.fileAttachments.push(FileAttachmentDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActivityRedemptionRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityRedemptionRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityDate"] = this.activityDate ? this.activityDate.toISOString() : <any>undefined;
        data["detail"] = this.detail ? this.detail.toJSON() : <any>undefined;
        data["directRewardRequest"] = this.directRewardRequest ? this.directRewardRequest.toJSON() : <any>undefined;
        if (Array.isArray(this.fileAttachments)) {
            data["fileAttachments"] = [];
            for (let item of this.fileAttachments)
                data["fileAttachments"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IActivityRedemptionRequestDTO {
    /** activity date */
    activityDate?: moment.Moment | undefined;
    /** set if it's a multiple reedamable activity */
    detail?: MultipleRedeemableActivityDetailDTO | undefined;
    /** set for direct award */
    directRewardRequest?: DirectRewardRequestDTO | undefined;
    fileAttachments?: FileAttachmentDTO[] | undefined;
}

export class AdditionalInsuredRegistrationDTO implements IAdditionalInsuredRegistrationDTO {
    firstname?: string | undefined;
    kvnr?: string | undefined;

    constructor(data?: IAdditionalInsuredRegistrationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstname = _data["firstname"];
            this.kvnr = _data["kvnr"];
        }
    }

    static fromJS(data: any): AdditionalInsuredRegistrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalInsuredRegistrationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstname"] = this.firstname;
        data["kvnr"] = this.kvnr;
        return data; 
    }
}

export interface IAdditionalInsuredRegistrationDTO {
    firstname?: string | undefined;
    kvnr?: string | undefined;
}

export class AddressDTO implements IAddressDTO {
    city?: string | undefined;
    street?: string | undefined;
    streetNumber?: string | undefined;
    zip?: string | undefined;

    constructor(data?: IAddressDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNumber = _data["streetNumber"];
            this.zip = _data["zip"];
        }
    }

    static fromJS(data: any): AddressDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNumber"] = this.streetNumber;
        data["zip"] = this.zip;
        return data; 
    }
}

export interface IAddressDTO {
    city?: string | undefined;
    street?: string | undefined;
    streetNumber?: string | undefined;
    zip?: string | undefined;
}

export class AokErrotDTOCodeI implements IAokErrotDTOCodeI {
    code?: AokErrotDTOCodeICode | undefined;
    codeAok?: AokErrotDTOCodeICodeAok | undefined;

    constructor(data?: IAokErrotDTOCodeI) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.codeAok = _data["codeAok"];
        }
    }

    static fromJS(data: any): AokErrotDTOCodeI {
        data = typeof data === 'object' ? data : {};
        let result = new AokErrotDTOCodeI();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["codeAok"] = this.codeAok;
        return data; 
    }
}

export interface IAokErrotDTOCodeI {
    code?: AokErrotDTOCodeICode | undefined;
    codeAok?: AokErrotDTOCodeICodeAok | undefined;
}

export class ChangePasswordDTO implements IChangePasswordDTO {
    newPassword?: string | undefined;
    oldPassword?: string | undefined;

    constructor(data?: IChangePasswordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"];
            this.oldPassword = _data["oldPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword;
        data["oldPassword"] = this.oldPassword;
        return data; 
    }
}

export interface IChangePasswordDTO {
    newPassword?: string | undefined;
    oldPassword?: string | undefined;
}

export class ChequeBookDTO implements IChequeBookDTO {
    /** The list of activities which the chequebook contains. Minimum is 1 */
    activities?: ActivityDTO[] | undefined;
    /** The year of the chequebook */
    year?: number | undefined;

    constructor(data?: IChequeBookDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities.push(ActivityDTO.fromJS(item));
            }
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): ChequeBookDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChequeBookDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        data["year"] = this.year;
        return data; 
    }
}

export interface IChequeBookDTO {
    /** The list of activities which the chequebook contains. Minimum is 1 */
    activities?: ActivityDTO[] | undefined;
    /** The year of the chequebook */
    year?: number | undefined;
}

export class ChequeDocumentDetailsDTO implements IChequeDocumentDetailsDTO {
    catchPhrase?: string | undefined;
    description?: string | undefined;
    signatureText?: string | undefined;
    suffixText?: string | undefined;

    constructor(data?: IChequeDocumentDetailsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.catchPhrase = _data["catchPhrase"];
            this.description = _data["description"];
            this.signatureText = _data["signatureText"];
            this.suffixText = _data["suffixText"];
        }
    }

    static fromJS(data: any): ChequeDocumentDetailsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChequeDocumentDetailsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["catchPhrase"] = this.catchPhrase;
        data["description"] = this.description;
        data["signatureText"] = this.signatureText;
        data["suffixText"] = this.suffixText;
        return data; 
    }
}

export interface IChequeDocumentDetailsDTO {
    catchPhrase?: string | undefined;
    description?: string | undefined;
    signatureText?: string | undefined;
    suffixText?: string | undefined;
}

export class CommunityMemberDTO implements ICommunityMemberDTO {
    additionalInsured?: RelatedCommunityMemberDTO[] | undefined;
    addressSupplement?: string | undefined;
    advertisingConsentDate?: moment.Moment | undefined;
    birthday?: moment.Moment | undefined;
    city?: string | undefined;
    countryCode?: string | undefined;
    firstname?: string | undefined;
    kvnr?: string | undefined;
    lastname?: string | undefined;
    mainCollector?: boolean | undefined;
    membership?: MembershipAokDTO | undefined;
    namePrefix?: string | undefined;
    phone1?: string | undefined;
    phone2?: string | undefined;
    salutation?: string | undefined;
    street?: string | undefined;
    streetNo?: string | undefined;
    taxIdentNumber?: string | undefined;
    title?: string | undefined;
    zip?: string | undefined;

    constructor(data?: ICommunityMemberDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["additionalInsured"])) {
                this.additionalInsured = [] as any;
                for (let item of _data["additionalInsured"])
                    this.additionalInsured.push(RelatedCommunityMemberDTO.fromJS(item));
            }
            this.addressSupplement = _data["addressSupplement"];
            this.advertisingConsentDate = _data["advertisingConsentDate"] ? moment(_data["advertisingConsentDate"].toString()) : <any>undefined;
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.city = _data["city"];
            this.countryCode = _data["countryCode"];
            this.firstname = _data["firstname"];
            this.kvnr = _data["kvnr"];
            this.lastname = _data["lastname"];
            this.mainCollector = _data["mainCollector"];
            this.membership = _data["membership"] ? MembershipAokDTO.fromJS(_data["membership"]) : <any>undefined;
            this.namePrefix = _data["namePrefix"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.salutation = _data["salutation"];
            this.street = _data["street"];
            this.streetNo = _data["streetNo"];
            this.taxIdentNumber = _data["taxIdentNumber"];
            this.title = _data["title"];
            this.zip = _data["zip"];
        }
    }

    static fromJS(data: any): CommunityMemberDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CommunityMemberDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.additionalInsured)) {
            data["additionalInsured"] = [];
            for (let item of this.additionalInsured)
                data["additionalInsured"].push(item.toJSON());
        }
        data["addressSupplement"] = this.addressSupplement;
        data["advertisingConsentDate"] = this.advertisingConsentDate ? this.advertisingConsentDate.toISOString() : <any>undefined;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["city"] = this.city;
        data["countryCode"] = this.countryCode;
        data["firstname"] = this.firstname;
        data["kvnr"] = this.kvnr;
        data["lastname"] = this.lastname;
        data["mainCollector"] = this.mainCollector;
        data["membership"] = this.membership ? this.membership.toJSON() : <any>undefined;
        data["namePrefix"] = this.namePrefix;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["salutation"] = this.salutation;
        data["street"] = this.street;
        data["streetNo"] = this.streetNo;
        data["taxIdentNumber"] = this.taxIdentNumber;
        data["title"] = this.title;
        data["zip"] = this.zip;
        return data; 
    }
}

export interface ICommunityMemberDTO {
    additionalInsured?: RelatedCommunityMemberDTO[] | undefined;
    addressSupplement?: string | undefined;
    advertisingConsentDate?: moment.Moment | undefined;
    birthday?: moment.Moment | undefined;
    city?: string | undefined;
    countryCode?: string | undefined;
    firstname?: string | undefined;
    kvnr?: string | undefined;
    lastname?: string | undefined;
    mainCollector?: boolean | undefined;
    membership?: MembershipAokDTO | undefined;
    namePrefix?: string | undefined;
    phone1?: string | undefined;
    phone2?: string | undefined;
    salutation?: string | undefined;
    street?: string | undefined;
    streetNo?: string | undefined;
    taxIdentNumber?: string | undefined;
    title?: string | undefined;
    zip?: string | undefined;
}

export class ConfigurationDTO implements IConfigurationDTO {
    displayValue?: string | undefined;
    key?: string | undefined;

    constructor(data?: IConfigurationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayValue = _data["displayValue"];
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): ConfigurationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayValue"] = this.displayValue;
        data["key"] = this.key;
        return data; 
    }
}

export interface IConfigurationDTO {
    displayValue?: string | undefined;
    key?: string | undefined;
}

export class CreateOnlineAccessRequestDTO implements ICreateOnlineAccessRequestDTO {
    birthDate?: moment.Moment | undefined;
    email?: string | undefined;
    kvnr?: string | undefined;
    /** mobile phone number in format: (\+|0)[0-9]{1,19} */
    phone2FA?: string | undefined;

    constructor(data?: ICreateOnlineAccessRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.kvnr = _data["kvnr"];
            this.phone2FA = _data["phone2FA"];
        }
    }

    static fromJS(data: any): CreateOnlineAccessRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOnlineAccessRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["kvnr"] = this.kvnr;
        data["phone2FA"] = this.phone2FA;
        return data; 
    }
}

export interface ICreateOnlineAccessRequestDTO {
    birthDate?: moment.Moment | undefined;
    email?: string | undefined;
    kvnr?: string | undefined;
    /** mobile phone number in format: (\+|0)[0-9]{1,19} */
    phone2FA?: string | undefined;
}

export class DeliveryAddressDTO implements IDeliveryAddressDTO {
    addressSupplement?: string | undefined;
    city?: string | undefined;
    countryCode?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    namePrefix?: string | undefined;
    salutation?: DeliveryAddressDTOSalutation | undefined;
    street?: string | undefined;
    streetNo?: string | undefined;
    title?: string | undefined;
    zip?: string | undefined;

    constructor(data?: IDeliveryAddressDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressSupplement = _data["addressSupplement"];
            this.city = _data["city"];
            this.countryCode = _data["countryCode"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.namePrefix = _data["namePrefix"];
            this.salutation = _data["salutation"];
            this.street = _data["street"];
            this.streetNo = _data["streetNo"];
            this.title = _data["title"];
            this.zip = _data["zip"];
        }
    }

    static fromJS(data: any): DeliveryAddressDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryAddressDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressSupplement"] = this.addressSupplement;
        data["city"] = this.city;
        data["countryCode"] = this.countryCode;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["namePrefix"] = this.namePrefix;
        data["salutation"] = this.salutation;
        data["street"] = this.street;
        data["streetNo"] = this.streetNo;
        data["title"] = this.title;
        data["zip"] = this.zip;
        return data; 
    }
}

export interface IDeliveryAddressDTO {
    addressSupplement?: string | undefined;
    city?: string | undefined;
    countryCode?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    namePrefix?: string | undefined;
    salutation?: DeliveryAddressDTOSalutation | undefined;
    street?: string | undefined;
    streetNo?: string | undefined;
    title?: string | undefined;
    zip?: string | undefined;
}

export class DirectRewardRequestDTO implements IDirectRewardRequestDTO {
    /** IBAN for DirectReward. Mandatory because all direct rewards are money rewards. */
    iban?: string | undefined;

    constructor(data?: IDirectRewardRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iban = _data["iban"];
        }
    }

    static fromJS(data: any): DirectRewardRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DirectRewardRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iban"] = this.iban;
        return data; 
    }
}

export interface IDirectRewardRequestDTO {
    /** IBAN for DirectReward. Mandatory because all direct rewards are money rewards. */
    iban?: string | undefined;
}

/** Domain error information */
export class ErrorDTO implements IErrorDTO {
    /** Error-Code of application */
    errorCode?: string | undefined;
    /** Exception message */
    errorMessages?: string[] | undefined;
    /** Subcode for more specific error */
    errorSubcode?: string | undefined;
    /** Exception which has occured */
    exception?: string | undefined;

    constructor(data?: IErrorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorCode = _data["errorCode"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
            this.errorSubcode = _data["errorSubcode"];
            this.exception = _data["exception"];
        }
    }

    static fromJS(data: any): ErrorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorCode"] = this.errorCode;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["errorSubcode"] = this.errorSubcode;
        data["exception"] = this.exception;
        return data; 
    }
}

/** Domain error information */
export interface IErrorDTO {
    /** Error-Code of application */
    errorCode?: string | undefined;
    /** Exception message */
    errorMessages?: string[] | undefined;
    /** Subcode for more specific error */
    errorSubcode?: string | undefined;
    /** Exception which has occured */
    exception?: string | undefined;
}

export class ErrorDTOAokSubcodeI implements IErrorDTOAokSubcodeI {
    subcode?: ErrorDTOAokSubcodeISubcode | undefined;
    subcodeAok?: ErrorDTOAokSubcodeISubcodeAok | undefined;

    constructor(data?: IErrorDTOAokSubcodeI) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subcode = _data["subcode"];
            this.subcodeAok = _data["subcodeAok"];
        }
    }

    static fromJS(data: any): ErrorDTOAokSubcodeI {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDTOAokSubcodeI();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subcode"] = this.subcode;
        data["subcodeAok"] = this.subcodeAok;
        return data; 
    }
}

export interface IErrorDTOAokSubcodeI {
    subcode?: ErrorDTOAokSubcodeISubcode | undefined;
    subcodeAok?: ErrorDTOAokSubcodeISubcodeAok | undefined;
}

/** Result object for the expiring points to the next expiry date in UC S-009 and A-009 */
export class ExpiringPointsResponseDTO implements IExpiringPointsResponseDTO {
    expiryDate?: moment.Moment | undefined;
    expiryPoints?: number | undefined;

    constructor(data?: IExpiringPointsResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expiryDate = _data["expiryDate"] ? moment(_data["expiryDate"].toString()) : <any>undefined;
            this.expiryPoints = _data["expiryPoints"];
        }
    }

    static fromJS(data: any): ExpiringPointsResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExpiringPointsResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        data["expiryPoints"] = this.expiryPoints;
        return data; 
    }
}

/** Result object for the expiring points to the next expiry date in UC S-009 and A-009 */
export interface IExpiringPointsResponseDTO {
    expiryDate?: moment.Moment | undefined;
    expiryPoints?: number | undefined;
}

/** Extended Reward DTO. */
export class ExtendedRewardDTO implements IExtendedRewardDTO {
    /** Generated article number --> See Flexpoint --> F-001 */
    articleNumber?: string | undefined;
    category?: ExtendedRewardDTOCategory | undefined;
    description?: string | undefined;
    /** true if it's a direct reward (Einzelbonus) */
    directReward?: boolean | undefined;
    /** formatted description */
    formattedDescription?: string | undefined;
    group?: ExtendedRewardDTOGroup | undefined;
    id?: number | undefined;
    name?: string | undefined;
    /** resources */
    resources?: ResourceReferenceDTO[] | undefined;
    /** thumbnail */
    thumbnail?: ResourceReferenceDTO | undefined;
    type?: ExtendedRewardDTOType | undefined;
    validFrom?: moment.Moment | undefined;
    /** Must be AFTER "valid from" */
    validTo?: moment.Moment | undefined;
    /** Value in points */
    value?: number | undefined;
    /** Value of the reward in EUR */
    valueInEUR?: number | undefined;

    constructor(data?: IExtendedRewardDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleNumber = _data["articleNumber"];
            this.category = _data["category"];
            this.description = _data["description"];
            this.directReward = _data["directReward"];
            this.formattedDescription = _data["formattedDescription"];
            this.group = _data["group"];
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["resources"])) {
                this.resources = [] as any;
                for (let item of _data["resources"])
                    this.resources.push(ResourceReferenceDTO.fromJS(item));
            }
            this.thumbnail = _data["thumbnail"] ? ResourceReferenceDTO.fromJS(_data["thumbnail"]) : <any>undefined;
            this.type = _data["type"];
            this.validFrom = _data["validFrom"] ? moment(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? moment(_data["validTo"].toString()) : <any>undefined;
            this.value = _data["value"];
            this.valueInEUR = _data["valueInEUR"];
        }
    }

    static fromJS(data: any): ExtendedRewardDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendedRewardDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleNumber"] = this.articleNumber;
        data["category"] = this.category;
        data["description"] = this.description;
        data["directReward"] = this.directReward;
        data["formattedDescription"] = this.formattedDescription;
        data["group"] = this.group;
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.resources)) {
            data["resources"] = [];
            for (let item of this.resources)
                data["resources"].push(item.toJSON());
        }
        data["thumbnail"] = this.thumbnail ? this.thumbnail.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["value"] = this.value;
        data["valueInEUR"] = this.valueInEUR;
        return data; 
    }
}

/** Extended Reward DTO. */
export interface IExtendedRewardDTO {
    /** Generated article number --> See Flexpoint --> F-001 */
    articleNumber?: string | undefined;
    category?: ExtendedRewardDTOCategory | undefined;
    description?: string | undefined;
    /** true if it's a direct reward (Einzelbonus) */
    directReward?: boolean | undefined;
    /** formatted description */
    formattedDescription?: string | undefined;
    group?: ExtendedRewardDTOGroup | undefined;
    id?: number | undefined;
    name?: string | undefined;
    /** resources */
    resources?: ResourceReferenceDTO[] | undefined;
    /** thumbnail */
    thumbnail?: ResourceReferenceDTO | undefined;
    type?: ExtendedRewardDTOType | undefined;
    validFrom?: moment.Moment | undefined;
    /** Must be AFTER "valid from" */
    validTo?: moment.Moment | undefined;
    /** Value in points */
    value?: number | undefined;
    /** Value of the reward in EUR */
    valueInEUR?: number | undefined;
}

export class FeedbackDTO implements IFeedbackDTO {
    birthDate?: moment.Moment | undefined;
    city?: string | undefined;
    countryCode?: string | undefined;
    email?: string | undefined;
    firstname?: string | undefined;
    kvnr?: string | undefined;
    lastname?: string | undefined;
    message?: string | undefined;
    namePrefix?: string | undefined;
    phone?: string | undefined;
    salutation?: FeedbackDTOSalutation | undefined;
    street?: string | undefined;
    streetNo?: string | undefined;
    subject?: string | undefined;
    title?: string | undefined;
    zip?: string | undefined;

    constructor(data?: IFeedbackDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.city = _data["city"];
            this.countryCode = _data["countryCode"];
            this.email = _data["email"];
            this.firstname = _data["firstname"];
            this.kvnr = _data["kvnr"];
            this.lastname = _data["lastname"];
            this.message = _data["message"];
            this.namePrefix = _data["namePrefix"];
            this.phone = _data["phone"];
            this.salutation = _data["salutation"];
            this.street = _data["street"];
            this.streetNo = _data["streetNo"];
            this.subject = _data["subject"];
            this.title = _data["title"];
            this.zip = _data["zip"];
        }
    }

    static fromJS(data: any): FeedbackDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["city"] = this.city;
        data["countryCode"] = this.countryCode;
        data["email"] = this.email;
        data["firstname"] = this.firstname;
        data["kvnr"] = this.kvnr;
        data["lastname"] = this.lastname;
        data["message"] = this.message;
        data["namePrefix"] = this.namePrefix;
        data["phone"] = this.phone;
        data["salutation"] = this.salutation;
        data["street"] = this.street;
        data["streetNo"] = this.streetNo;
        data["subject"] = this.subject;
        data["title"] = this.title;
        data["zip"] = this.zip;
        return data; 
    }
}

export interface IFeedbackDTO {
    birthDate?: moment.Moment | undefined;
    city?: string | undefined;
    countryCode?: string | undefined;
    email?: string | undefined;
    firstname?: string | undefined;
    kvnr?: string | undefined;
    lastname?: string | undefined;
    message?: string | undefined;
    namePrefix?: string | undefined;
    phone?: string | undefined;
    salutation?: FeedbackDTOSalutation | undefined;
    street?: string | undefined;
    streetNo?: string | undefined;
    subject?: string | undefined;
    title?: string | undefined;
    zip?: string | undefined;
}

export class FileAttachmentDTO implements IFileAttachmentDTO {
    /** The content of the file as a base64 encoded string */
    content?: string | undefined;
    /** Mime-Type of the file attachment */
    mimeType?: string | undefined;

    constructor(data?: IFileAttachmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"];
            this.mimeType = _data["mimeType"];
        }
    }

    static fromJS(data: any): FileAttachmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FileAttachmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["mimeType"] = this.mimeType;
        return data; 
    }
}

export interface IFileAttachmentDTO {
    /** The content of the file as a base64 encoded string */
    content?: string | undefined;
    /** Mime-Type of the file attachment */
    mimeType?: string | undefined;
}

/** Request object for get account balance in UC S-009 */
export class GetAccountBalanceRequestDTO implements IGetAccountBalanceRequestDTO {
    /** Start Date of Query (optional) with format yyyy-MM-dd */
    endDate?: moment.Moment | undefined;
    /** Start Date of Query (optional) with format yyyy-MM-dd */
    startDate?: moment.Moment | undefined;

    constructor(data?: IGetAccountBalanceRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAccountBalanceRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountBalanceRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        return data; 
    }
}

/** Request object for get account balance in UC S-009 */
export interface IGetAccountBalanceRequestDTO {
    /** Start Date of Query (optional) with format yyyy-MM-dd */
    endDate?: moment.Moment | undefined;
    /** Start Date of Query (optional) with format yyyy-MM-dd */
    startDate?: moment.Moment | undefined;
}

export class GetStatusResultDTO implements IGetStatusResultDTO {
    alreadyRegistered?: boolean | undefined;
    onlineAccessExists?: boolean | undefined;

    constructor(data?: IGetStatusResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alreadyRegistered = _data["alreadyRegistered"];
            this.onlineAccessExists = _data["onlineAccessExists"];
        }
    }

    static fromJS(data: any): GetStatusResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetStatusResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alreadyRegistered"] = this.alreadyRegistered;
        data["onlineAccessExists"] = this.onlineAccessExists;
        return data; 
    }
}

export interface IGetStatusResultDTO {
    alreadyRegistered?: boolean | undefined;
    onlineAccessExists?: boolean | undefined;
}

export class LoyaltyProgramActivityPrototypeDTO implements ILoyaltyProgramActivityPrototypeDTO {
    /** internal category of this prototype */
    category?: string | undefined;
    /** external category of this prototype */
    categoryExternal?: string | undefined;
    /** direct reward enabled */
    directRewardEnabled?: boolean | undefined;
    /** ensure redeemable activity in Chequebook */
    ensureRedeemableActivityInChequebook?: boolean | undefined;
    /** Formatted description */
    formattedDescription?: string | undefined;
    /** id in db for this prototype */
    id?: number | undefined;
    /** Ignore activity for max pont calculation */
    ignoreForMaxPointCalculation?: boolean | undefined;
    /** key for this prototype */
    key?: string | undefined;
    /** internal name of this prototype */
    name?: string | undefined;
    /** external name of this prototype */
    nameExternal?: string | undefined;
    /** resources */
    resources?: ResourceReferenceDTO[] | undefined;
    /** thumbnail */
    thumbnail?: ResourceReferenceDTO | undefined;
    /** validFrom */
    validFrom?: moment.Moment | undefined;
    /** validTo */
    validTo?: moment.Moment | undefined;
    /** value (e.g. Punkte) for this prototype */
    value?: number | undefined;

    constructor(data?: ILoyaltyProgramActivityPrototypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.categoryExternal = _data["categoryExternal"];
            this.directRewardEnabled = _data["directRewardEnabled"];
            this.ensureRedeemableActivityInChequebook = _data["ensureRedeemableActivityInChequebook"];
            this.formattedDescription = _data["formattedDescription"];
            this.id = _data["id"];
            this.ignoreForMaxPointCalculation = _data["ignoreForMaxPointCalculation"];
            this.key = _data["key"];
            this.name = _data["name"];
            this.nameExternal = _data["nameExternal"];
            if (Array.isArray(_data["resources"])) {
                this.resources = [] as any;
                for (let item of _data["resources"])
                    this.resources.push(ResourceReferenceDTO.fromJS(item));
            }
            this.thumbnail = _data["thumbnail"] ? ResourceReferenceDTO.fromJS(_data["thumbnail"]) : <any>undefined;
            this.validFrom = _data["validFrom"] ? moment(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? moment(_data["validTo"].toString()) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): LoyaltyProgramActivityPrototypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LoyaltyProgramActivityPrototypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["categoryExternal"] = this.categoryExternal;
        data["directRewardEnabled"] = this.directRewardEnabled;
        data["ensureRedeemableActivityInChequebook"] = this.ensureRedeemableActivityInChequebook;
        data["formattedDescription"] = this.formattedDescription;
        data["id"] = this.id;
        data["ignoreForMaxPointCalculation"] = this.ignoreForMaxPointCalculation;
        data["key"] = this.key;
        data["name"] = this.name;
        data["nameExternal"] = this.nameExternal;
        if (Array.isArray(this.resources)) {
            data["resources"] = [];
            for (let item of this.resources)
                data["resources"].push(item.toJSON());
        }
        data["thumbnail"] = this.thumbnail ? this.thumbnail.toJSON() : <any>undefined;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["value"] = this.value;
        return data; 
    }
}

export interface ILoyaltyProgramActivityPrototypeDTO {
    /** internal category of this prototype */
    category?: string | undefined;
    /** external category of this prototype */
    categoryExternal?: string | undefined;
    /** direct reward enabled */
    directRewardEnabled?: boolean | undefined;
    /** ensure redeemable activity in Chequebook */
    ensureRedeemableActivityInChequebook?: boolean | undefined;
    /** Formatted description */
    formattedDescription?: string | undefined;
    /** id in db for this prototype */
    id?: number | undefined;
    /** Ignore activity for max pont calculation */
    ignoreForMaxPointCalculation?: boolean | undefined;
    /** key for this prototype */
    key?: string | undefined;
    /** internal name of this prototype */
    name?: string | undefined;
    /** external name of this prototype */
    nameExternal?: string | undefined;
    /** resources */
    resources?: ResourceReferenceDTO[] | undefined;
    /** thumbnail */
    thumbnail?: ResourceReferenceDTO | undefined;
    /** validFrom */
    validFrom?: moment.Moment | undefined;
    /** validTo */
    validTo?: moment.Moment | undefined;
    /** value (e.g. Punkte) for this prototype */
    value?: number | undefined;
}

/** Loyalty Program DTO for App. */
export class LoyaltyProgramDTO implements ILoyaltyProgramDTO {
    /** ID of the Loyalty program. */
    id?: number | undefined;
    /** Name of the Loyalty program. */
    name?: string | undefined;
    programType?: string | undefined;
    /** If Activity Levels are enabled or not. */
    useActivityLevels?: boolean | undefined;

    constructor(data?: ILoyaltyProgramDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.programType = _data["programType"];
            this.useActivityLevels = _data["useActivityLevels"];
        }
    }

    static fromJS(data: any): LoyaltyProgramDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LoyaltyProgramDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["programType"] = this.programType;
        data["useActivityLevels"] = this.useActivityLevels;
        return data; 
    }
}

/** Loyalty Program DTO for App. */
export interface ILoyaltyProgramDTO {
    /** ID of the Loyalty program. */
    id?: number | undefined;
    /** Name of the Loyalty program. */
    name?: string | undefined;
    programType?: string | undefined;
    /** If Activity Levels are enabled or not. */
    useActivityLevels?: boolean | undefined;
}

/** Loyalty Program FAQ DTO. */
export class LoyaltyProgramFAQDTO implements ILoyaltyProgramFAQDTO {
    category?: string | undefined;
    formattedAnswer?: string | undefined;
    question?: string | undefined;
    resources?: ResourceReferenceDTO[] | undefined;
    thumbnail?: ResourceReferenceDTO | undefined;

    constructor(data?: ILoyaltyProgramFAQDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.formattedAnswer = _data["formattedAnswer"];
            this.question = _data["question"];
            if (Array.isArray(_data["resources"])) {
                this.resources = [] as any;
                for (let item of _data["resources"])
                    this.resources.push(ResourceReferenceDTO.fromJS(item));
            }
            this.thumbnail = _data["thumbnail"] ? ResourceReferenceDTO.fromJS(_data["thumbnail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LoyaltyProgramFAQDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LoyaltyProgramFAQDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["formattedAnswer"] = this.formattedAnswer;
        data["question"] = this.question;
        if (Array.isArray(this.resources)) {
            data["resources"] = [];
            for (let item of this.resources)
                data["resources"].push(item.toJSON());
        }
        data["thumbnail"] = this.thumbnail ? this.thumbnail.toJSON() : <any>undefined;
        return data; 
    }
}

/** Loyalty Program FAQ DTO. */
export interface ILoyaltyProgramFAQDTO {
    category?: string | undefined;
    formattedAnswer?: string | undefined;
    question?: string | undefined;
    resources?: ResourceReferenceDTO[] | undefined;
    thumbnail?: ResourceReferenceDTO | undefined;
}

/** Loyalty Program News DTO. */
export class LoyaltyProgramNewsDTO implements ILoyaltyProgramNewsDTO {
    category?: string | undefined;
    formattedContent?: string | undefined;
    id?: number | undefined;
    resources?: ResourceReferenceDTO[] | undefined;
    shortDescription?: string | undefined;
    thumbnail?: ResourceReferenceDTO | undefined;
    title?: string | undefined;
    validFrom?: moment.Moment | undefined;

    constructor(data?: ILoyaltyProgramNewsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.formattedContent = _data["formattedContent"];
            this.id = _data["id"];
            if (Array.isArray(_data["resources"])) {
                this.resources = [] as any;
                for (let item of _data["resources"])
                    this.resources.push(ResourceReferenceDTO.fromJS(item));
            }
            this.shortDescription = _data["shortDescription"];
            this.thumbnail = _data["thumbnail"] ? ResourceReferenceDTO.fromJS(_data["thumbnail"]) : <any>undefined;
            this.title = _data["title"];
            this.validFrom = _data["validFrom"] ? moment(_data["validFrom"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LoyaltyProgramNewsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LoyaltyProgramNewsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["formattedContent"] = this.formattedContent;
        data["id"] = this.id;
        if (Array.isArray(this.resources)) {
            data["resources"] = [];
            for (let item of this.resources)
                data["resources"].push(item.toJSON());
        }
        data["shortDescription"] = this.shortDescription;
        data["thumbnail"] = this.thumbnail ? this.thumbnail.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        return data; 
    }
}

/** Loyalty Program News DTO. */
export interface ILoyaltyProgramNewsDTO {
    category?: string | undefined;
    formattedContent?: string | undefined;
    id?: number | undefined;
    resources?: ResourceReferenceDTO[] | undefined;
    shortDescription?: string | undefined;
    thumbnail?: ResourceReferenceDTO | undefined;
    title?: string | undefined;
    validFrom?: moment.Moment | undefined;
}

export class MediaCodeDTO implements IMediaCodeDTO {
    description?: string | undefined;
    id?: number | undefined;
    name?: string | undefined;
    status?: MediaCodeDTOStatus | undefined;

    constructor(data?: IMediaCodeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): MediaCodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MediaCodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        return data; 
    }
}

export interface IMediaCodeDTO {
    description?: string | undefined;
    id?: number | undefined;
    name?: string | undefined;
    status?: MediaCodeDTOStatus | undefined;
}

export class MembershipAokDTO implements IMembershipAokDTO {
    cancellationDate?: moment.Moment | undefined;
    chequebookDelivery?: MembershipAokDTOChequebookDelivery | undefined;
    email?: string | undefined;
    endDate?: moment.Moment | undefined;
    loyaltyProgramId?: number | undefined;
    membershipId?: number | undefined;
    registrationDate?: moment.Moment | undefined;
    startDate?: moment.Moment | undefined;
    status?: string | undefined;

    constructor(data?: IMembershipAokDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cancellationDate = _data["cancellationDate"] ? moment(_data["cancellationDate"].toString()) : <any>undefined;
            this.chequebookDelivery = _data["chequebookDelivery"];
            this.email = _data["email"];
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.loyaltyProgramId = _data["loyaltyProgramId"];
            this.membershipId = _data["membershipId"];
            this.registrationDate = _data["registrationDate"] ? moment(_data["registrationDate"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): MembershipAokDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipAokDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cancellationDate"] = this.cancellationDate ? this.cancellationDate.toISOString() : <any>undefined;
        data["chequebookDelivery"] = this.chequebookDelivery;
        data["email"] = this.email;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["loyaltyProgramId"] = this.loyaltyProgramId;
        data["membershipId"] = this.membershipId;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data; 
    }
}

export interface IMembershipAokDTO {
    cancellationDate?: moment.Moment | undefined;
    chequebookDelivery?: MembershipAokDTOChequebookDelivery | undefined;
    email?: string | undefined;
    endDate?: moment.Moment | undefined;
    loyaltyProgramId?: number | undefined;
    membershipId?: number | undefined;
    registrationDate?: moment.Moment | undefined;
    startDate?: moment.Moment | undefined;
    status?: string | undefined;
}

export class MultipleRedeemableActivityDetailDTO implements IMultipleRedeemableActivityDetailDTO {
    /** detail for the activity e.g if the activity is just a general vaccination the detail here could be rubella */
    activityDetail?: string | undefined;
    /** Date when the activity was verified by the issueing authority (e.g. doctor) */
    verificationDate?: moment.Moment | undefined;

    constructor(data?: IMultipleRedeemableActivityDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityDetail = _data["activityDetail"];
            this.verificationDate = _data["verificationDate"] ? moment(_data["verificationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MultipleRedeemableActivityDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MultipleRedeemableActivityDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityDetail"] = this.activityDetail;
        data["verificationDate"] = this.verificationDate ? this.verificationDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IMultipleRedeemableActivityDetailDTO {
    /** detail for the activity e.g if the activity is just a general vaccination the detail here could be rubella */
    activityDetail?: string | undefined;
    /** Date when the activity was verified by the issueing authority (e.g. doctor) */
    verificationDate?: moment.Moment | undefined;
}

export class OrderDTO implements IOrderDTO {
    /** Address where the order should be delivered to */
    deliveryAddress?: DeliveryAddressDTO | undefined;
    /** Technical ID of the order */
    id?: number | undefined;
    /** Timestamp when the order was performed */
    orderDate?: moment.Moment | undefined;
    /** all order positions */
    orderItems?: OrderItemDTO[] | undefined;
    /** total sum of the order */
    value?: number | undefined;

    constructor(data?: IOrderDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deliveryAddress = _data["deliveryAddress"] ? DeliveryAddressDTO.fromJS(_data["deliveryAddress"]) : <any>undefined;
            this.id = _data["id"];
            this.orderDate = _data["orderDate"] ? moment(_data["orderDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems.push(OrderItemDTO.fromJS(item));
            }
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): OrderDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryAddress"] = this.deliveryAddress ? this.deliveryAddress.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        data["value"] = this.value;
        return data; 
    }
}

export interface IOrderDTO {
    /** Address where the order should be delivered to */
    deliveryAddress?: DeliveryAddressDTO | undefined;
    /** Technical ID of the order */
    id?: number | undefined;
    /** Timestamp when the order was performed */
    orderDate?: moment.Moment | undefined;
    /** all order positions */
    orderItems?: OrderItemDTO[] | undefined;
    /** total sum of the order */
    value?: number | undefined;
}

export class OrderItemDTO implements IOrderItemDTO {
    /** amount of items of this position */
    amount?: number | undefined;
    /** date when the (subvention) order was approved in the service center */
    approvalDate?: moment.Moment | undefined;
    /** article number for this order item */
    articleNumber?: string | undefined;
    /** cancel date of this item in case of cancellation or return */
    cancelDate?: moment.Moment | undefined;
    /** Transporteur for the order */
    carrier?: string | undefined;
    /** Code of the coupon. Only filled if Reward is of type COUPON */
    couponCode?: string | undefined;
    /** delivery date of this item */
    deliveryDate?: moment.Moment | undefined;
    /** description of the article in this order item */
    description?: string | undefined;
    /** true if it exists a document (like pdf) for that order. */
    documentAvailable?: boolean | undefined;
    /** Technical ID of the order item */
    id?: number | undefined;
    /** name of the article in this order item */
    name?: string | undefined;
    /** status of the order item */
    status?: OrderItemDTOStatus | undefined;
    /** ID used for order tracking */
    trackingID?: string | undefined;
    /** type of the order item reward */
    type?: OrderItemDTOType | undefined;
    /** value for each single unit of this order item */
    valuePerUnit?: number | undefined;

    constructor(data?: IOrderItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.approvalDate = _data["approvalDate"] ? moment(_data["approvalDate"].toString()) : <any>undefined;
            this.articleNumber = _data["articleNumber"];
            this.cancelDate = _data["cancelDate"] ? moment(_data["cancelDate"].toString()) : <any>undefined;
            this.carrier = _data["carrier"];
            this.couponCode = _data["couponCode"];
            this.deliveryDate = _data["deliveryDate"] ? moment(_data["deliveryDate"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.documentAvailable = _data["documentAvailable"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.trackingID = _data["trackingID"];
            this.type = _data["type"];
            this.valuePerUnit = _data["valuePerUnit"];
        }
    }

    static fromJS(data: any): OrderItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["approvalDate"] = this.approvalDate ? this.approvalDate.toISOString() : <any>undefined;
        data["articleNumber"] = this.articleNumber;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["carrier"] = this.carrier;
        data["couponCode"] = this.couponCode;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["documentAvailable"] = this.documentAvailable;
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["trackingID"] = this.trackingID;
        data["type"] = this.type;
        data["valuePerUnit"] = this.valuePerUnit;
        return data; 
    }
}

export interface IOrderItemDTO {
    /** amount of items of this position */
    amount?: number | undefined;
    /** date when the (subvention) order was approved in the service center */
    approvalDate?: moment.Moment | undefined;
    /** article number for this order item */
    articleNumber?: string | undefined;
    /** cancel date of this item in case of cancellation or return */
    cancelDate?: moment.Moment | undefined;
    /** Transporteur for the order */
    carrier?: string | undefined;
    /** Code of the coupon. Only filled if Reward is of type COUPON */
    couponCode?: string | undefined;
    /** delivery date of this item */
    deliveryDate?: moment.Moment | undefined;
    /** description of the article in this order item */
    description?: string | undefined;
    /** true if it exists a document (like pdf) for that order. */
    documentAvailable?: boolean | undefined;
    /** Technical ID of the order item */
    id?: number | undefined;
    /** name of the article in this order item */
    name?: string | undefined;
    /** status of the order item */
    status?: OrderItemDTOStatus | undefined;
    /** ID used for order tracking */
    trackingID?: string | undefined;
    /** type of the order item reward */
    type?: OrderItemDTOType | undefined;
    /** value for each single unit of this order item */
    valuePerUnit?: number | undefined;
}

export class OrderItemRequestDTO implements IOrderItemRequestDTO {
    /** ordered amount of the reward */
    amount?: number | undefined;
    /** IBAN if it is a money order item */
    iban?: string | undefined;
    /** Receiver Firstname */
    receiverFirstname?: string | undefined;
    /** Receiver KVNR number */
    receiverKVNR?: string | undefined;
    /** Receiver Lastname */
    receiverLastname?: string | undefined;
    /** Technical ID of the reward to order */
    rewardId?: number | undefined;

    constructor(data?: IOrderItemRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.iban = _data["iban"];
            this.receiverFirstname = _data["receiverFirstname"];
            this.receiverKVNR = _data["receiverKVNR"];
            this.receiverLastname = _data["receiverLastname"];
            this.rewardId = _data["rewardId"];
        }
    }

    static fromJS(data: any): OrderItemRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["iban"] = this.iban;
        data["receiverFirstname"] = this.receiverFirstname;
        data["receiverKVNR"] = this.receiverKVNR;
        data["receiverLastname"] = this.receiverLastname;
        data["rewardId"] = this.rewardId;
        return data; 
    }
}

export interface IOrderItemRequestDTO {
    /** ordered amount of the reward */
    amount?: number | undefined;
    /** IBAN if it is a money order item */
    iban?: string | undefined;
    /** Receiver Firstname */
    receiverFirstname?: string | undefined;
    /** Receiver KVNR number */
    receiverKVNR?: string | undefined;
    /** Receiver Lastname */
    receiverLastname?: string | undefined;
    /** Technical ID of the reward to order */
    rewardId?: number | undefined;
}

export class OrderRewardRequestDTO implements IOrderRewardRequestDTO {
    /** Delivery address where the order should be delivered to */
    deliveryAddress?: DeliveryAddressDTO | undefined;
    /** all order items which items should be ordered */
    items?: OrderItemRequestDTO[] | undefined;

    constructor(data?: IOrderRewardRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deliveryAddress = _data["deliveryAddress"] ? DeliveryAddressDTO.fromJS(_data["deliveryAddress"]) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderItemRequestDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderRewardRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderRewardRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryAddress"] = this.deliveryAddress ? this.deliveryAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IOrderRewardRequestDTO {
    /** Delivery address where the order should be delivered to */
    deliveryAddress?: DeliveryAddressDTO | undefined;
    /** all order items which items should be ordered */
    items?: OrderItemRequestDTO[] | undefined;
}

export class ParticipantAnnouncementDTO implements IParticipantAnnouncementDTO {
    category?: string | undefined;
    date?: moment.Moment | undefined;
    new?: boolean | undefined;
    text?: string | undefined;

    constructor(data?: IParticipantAnnouncementDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.new = _data["new"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): ParticipantAnnouncementDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantAnnouncementDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["new"] = this.new;
        data["text"] = this.text;
        return data; 
    }
}

export interface IParticipantAnnouncementDTO {
    category?: string | undefined;
    date?: moment.Moment | undefined;
    new?: boolean | undefined;
    text?: string | undefined;
}

export class PhvDTO implements IPhvDTO {
    additionalInsured?: PmvDTO[] | undefined;
    addressSupplement?: string | undefined;
    advertisingConsentDate?: moment.Moment | undefined;
    birthday?: moment.Moment | undefined;
    city?: string | undefined;
    countryCode?: string | undefined;
    firstname?: string | undefined;
    kvnr?: string | undefined;
    lastname?: string | undefined;
    membership?: MembershipAokDTO | undefined;
    namePrefix?: string | undefined;
    phone1?: string | undefined;
    phone2?: string | undefined;
    salutation?: string | undefined;
    street?: string | undefined;
    streetNo?: string | undefined;
    taxIdentNumber?: string | undefined;
    title?: string | undefined;
    zip?: string | undefined;

    constructor(data?: IPhvDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["additionalInsured"])) {
                this.additionalInsured = [] as any;
                for (let item of _data["additionalInsured"])
                    this.additionalInsured.push(PmvDTO.fromJS(item));
            }
            this.addressSupplement = _data["addressSupplement"];
            this.advertisingConsentDate = _data["advertisingConsentDate"] ? moment(_data["advertisingConsentDate"].toString()) : <any>undefined;
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.city = _data["city"];
            this.countryCode = _data["countryCode"];
            this.firstname = _data["firstname"];
            this.kvnr = _data["kvnr"];
            this.lastname = _data["lastname"];
            this.membership = _data["membership"] ? MembershipAokDTO.fromJS(_data["membership"]) : <any>undefined;
            this.namePrefix = _data["namePrefix"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.salutation = _data["salutation"];
            this.street = _data["street"];
            this.streetNo = _data["streetNo"];
            this.taxIdentNumber = _data["taxIdentNumber"];
            this.title = _data["title"];
            this.zip = _data["zip"];
        }
    }

    static fromJS(data: any): PhvDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PhvDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.additionalInsured)) {
            data["additionalInsured"] = [];
            for (let item of this.additionalInsured)
                data["additionalInsured"].push(item.toJSON());
        }
        data["addressSupplement"] = this.addressSupplement;
        data["advertisingConsentDate"] = this.advertisingConsentDate ? this.advertisingConsentDate.toISOString() : <any>undefined;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["city"] = this.city;
        data["countryCode"] = this.countryCode;
        data["firstname"] = this.firstname;
        data["kvnr"] = this.kvnr;
        data["lastname"] = this.lastname;
        data["membership"] = this.membership ? this.membership.toJSON() : <any>undefined;
        data["namePrefix"] = this.namePrefix;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["salutation"] = this.salutation;
        data["street"] = this.street;
        data["streetNo"] = this.streetNo;
        data["taxIdentNumber"] = this.taxIdentNumber;
        data["title"] = this.title;
        data["zip"] = this.zip;
        return data; 
    }
}

export interface IPhvDTO {
    additionalInsured?: PmvDTO[] | undefined;
    addressSupplement?: string | undefined;
    advertisingConsentDate?: moment.Moment | undefined;
    birthday?: moment.Moment | undefined;
    city?: string | undefined;
    countryCode?: string | undefined;
    firstname?: string | undefined;
    kvnr?: string | undefined;
    lastname?: string | undefined;
    membership?: MembershipAokDTO | undefined;
    namePrefix?: string | undefined;
    phone1?: string | undefined;
    phone2?: string | undefined;
    salutation?: string | undefined;
    street?: string | undefined;
    streetNo?: string | undefined;
    taxIdentNumber?: string | undefined;
    title?: string | undefined;
    zip?: string | undefined;
}

export class PmvDTO implements IPmvDTO {
    addressSupplement?: string | undefined;
    advertisingConsentDate?: moment.Moment | undefined;
    birthday?: moment.Moment | undefined;
    city?: string | undefined;
    countryCode?: string | undefined;
    firstname?: string | undefined;
    kvnr?: string | undefined;
    lastname?: string | undefined;
    membership?: MembershipAokDTO | undefined;
    namePrefix?: string | undefined;
    phone1?: string | undefined;
    phone2?: string | undefined;
    salutation?: string | undefined;
    street?: string | undefined;
    streetNo?: string | undefined;
    taxIdentNumber?: string | undefined;
    title?: string | undefined;
    zip?: string | undefined;

    constructor(data?: IPmvDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressSupplement = _data["addressSupplement"];
            this.advertisingConsentDate = _data["advertisingConsentDate"] ? moment(_data["advertisingConsentDate"].toString()) : <any>undefined;
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.city = _data["city"];
            this.countryCode = _data["countryCode"];
            this.firstname = _data["firstname"];
            this.kvnr = _data["kvnr"];
            this.lastname = _data["lastname"];
            this.membership = _data["membership"] ? MembershipAokDTO.fromJS(_data["membership"]) : <any>undefined;
            this.namePrefix = _data["namePrefix"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.salutation = _data["salutation"];
            this.street = _data["street"];
            this.streetNo = _data["streetNo"];
            this.taxIdentNumber = _data["taxIdentNumber"];
            this.title = _data["title"];
            this.zip = _data["zip"];
        }
    }

    static fromJS(data: any): PmvDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PmvDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressSupplement"] = this.addressSupplement;
        data["advertisingConsentDate"] = this.advertisingConsentDate ? this.advertisingConsentDate.toISOString() : <any>undefined;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["city"] = this.city;
        data["countryCode"] = this.countryCode;
        data["firstname"] = this.firstname;
        data["kvnr"] = this.kvnr;
        data["lastname"] = this.lastname;
        data["membership"] = this.membership ? this.membership.toJSON() : <any>undefined;
        data["namePrefix"] = this.namePrefix;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["salutation"] = this.salutation;
        data["street"] = this.street;
        data["streetNo"] = this.streetNo;
        data["taxIdentNumber"] = this.taxIdentNumber;
        data["title"] = this.title;
        data["zip"] = this.zip;
        return data; 
    }
}

export interface IPmvDTO {
    addressSupplement?: string | undefined;
    advertisingConsentDate?: moment.Moment | undefined;
    birthday?: moment.Moment | undefined;
    city?: string | undefined;
    countryCode?: string | undefined;
    firstname?: string | undefined;
    kvnr?: string | undefined;
    lastname?: string | undefined;
    membership?: MembershipAokDTO | undefined;
    namePrefix?: string | undefined;
    phone1?: string | undefined;
    phone2?: string | undefined;
    salutation?: string | undefined;
    street?: string | undefined;
    streetNo?: string | undefined;
    taxIdentNumber?: string | undefined;
    title?: string | undefined;
    zip?: string | undefined;
}

export class PostingDTO implements IPostingDTO {
    /** Description text of this posting */
    description?: string | undefined;
    /** reference to the KVNR */
    postedForKVNR?: string | undefined;
    /** reference to the name of the poster (firstName + " " + lastName */
    postedForName?: string | undefined;
    /** Posting date */
    postingDate?: moment.Moment | undefined;
    /** Type of the posting */
    postingType?: string | undefined;
    /** Transaction date */
    transactionDate?: moment.Moment | undefined;
    /** Value of the posting */
    value?: number | undefined;
    /** Not cleared value of this posting */
    valueNotCleared?: number | undefined;

    constructor(data?: IPostingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.postedForKVNR = _data["postedForKVNR"];
            this.postedForName = _data["postedForName"];
            this.postingDate = _data["postingDate"] ? moment(_data["postingDate"].toString()) : <any>undefined;
            this.postingType = _data["postingType"];
            this.transactionDate = _data["transactionDate"] ? moment(_data["transactionDate"].toString()) : <any>undefined;
            this.value = _data["value"];
            this.valueNotCleared = _data["valueNotCleared"];
        }
    }

    static fromJS(data: any): PostingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PostingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["postedForKVNR"] = this.postedForKVNR;
        data["postedForName"] = this.postedForName;
        data["postingDate"] = this.postingDate ? this.postingDate.toISOString() : <any>undefined;
        data["postingType"] = this.postingType;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["value"] = this.value;
        data["valueNotCleared"] = this.valueNotCleared;
        return data; 
    }
}

export interface IPostingDTO {
    /** Description text of this posting */
    description?: string | undefined;
    /** reference to the KVNR */
    postedForKVNR?: string | undefined;
    /** reference to the name of the poster (firstName + " " + lastName */
    postedForName?: string | undefined;
    /** Posting date */
    postingDate?: moment.Moment | undefined;
    /** Type of the posting */
    postingType?: string | undefined;
    /** Transaction date */
    transactionDate?: moment.Moment | undefined;
    /** Value of the posting */
    value?: number | undefined;
    /** Not cleared value of this posting */
    valueNotCleared?: number | undefined;
}

/** Parameter for the query of statements */
export class QueryAccountStatementRequestDTO implements IQueryAccountStatementRequestDTO {
    /** Index of the page to query. Starts with 0 */
    pageNumber?: number | undefined;
    /** Page size to query. Minimum is 1 */
    pageQuantity?: number | undefined;
    /** End Date of Query (optional) with format yyyy-MM-dd */
    statementEndDate?: moment.Moment | undefined;
    /** Start Date of Query (optional) with format yyyy-MM-dd */
    statementStartDate?: moment.Moment | undefined;

    constructor(data?: IQueryAccountStatementRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageQuantity = _data["pageQuantity"];
            this.statementEndDate = _data["statementEndDate"] ? moment(_data["statementEndDate"].toString()) : <any>undefined;
            this.statementStartDate = _data["statementStartDate"] ? moment(_data["statementStartDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): QueryAccountStatementRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QueryAccountStatementRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageQuantity"] = this.pageQuantity;
        data["statementEndDate"] = this.statementEndDate ? this.statementEndDate.toISOString() : <any>undefined;
        data["statementStartDate"] = this.statementStartDate ? this.statementStartDate.toISOString() : <any>undefined;
        return data; 
    }
}

/** Parameter for the query of statements */
export interface IQueryAccountStatementRequestDTO {
    /** Index of the page to query. Starts with 0 */
    pageNumber?: number | undefined;
    /** Page size to query. Minimum is 1 */
    pageQuantity?: number | undefined;
    /** End Date of Query (optional) with format yyyy-MM-dd */
    statementEndDate?: moment.Moment | undefined;
    /** Start Date of Query (optional) with format yyyy-MM-dd */
    statementStartDate?: moment.Moment | undefined;
}

export class QueryParticipantAnouncementRequestDTO implements IQueryParticipantAnouncementRequestDTO {
    /** Page Number you want to load */
    pageNumber?: number | undefined;
    /** Size of every page */
    pageQuantity?: number | undefined;
    updateAppLastUsed?: boolean | undefined;

    constructor(data?: IQueryParticipantAnouncementRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageQuantity = _data["pageQuantity"];
            this.updateAppLastUsed = _data["updateAppLastUsed"];
        }
    }

    static fromJS(data: any): QueryParticipantAnouncementRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QueryParticipantAnouncementRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageQuantity"] = this.pageQuantity;
        data["updateAppLastUsed"] = this.updateAppLastUsed;
        return data; 
    }
}

export interface IQueryParticipantAnouncementRequestDTO {
    /** Page Number you want to load */
    pageNumber?: number | undefined;
    /** Size of every page */
    pageQuantity?: number | undefined;
    updateAppLastUsed?: boolean | undefined;
}

export class QueryParticipantAnouncementResultDTO implements IQueryParticipantAnouncementResultDTO {
    /** Found announcements on this page */
    announcements?: ParticipantAnnouncementDTO[] | undefined;
    /** Displayed page number */
    pageNumber?: number | undefined;
    /** Result page size */
    pageResultQuantity?: number | undefined;
    /** Total found results */
    totalResultQuantity?: number | undefined;

    constructor(data?: IQueryParticipantAnouncementResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["announcements"])) {
                this.announcements = [] as any;
                for (let item of _data["announcements"])
                    this.announcements.push(ParticipantAnnouncementDTO.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageResultQuantity = _data["pageResultQuantity"];
            this.totalResultQuantity = _data["totalResultQuantity"];
        }
    }

    static fromJS(data: any): QueryParticipantAnouncementResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QueryParticipantAnouncementResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.announcements)) {
            data["announcements"] = [];
            for (let item of this.announcements)
                data["announcements"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["pageResultQuantity"] = this.pageResultQuantity;
        data["totalResultQuantity"] = this.totalResultQuantity;
        return data; 
    }
}

export interface IQueryParticipantAnouncementResultDTO {
    /** Found announcements on this page */
    announcements?: ParticipantAnnouncementDTO[] | undefined;
    /** Displayed page number */
    pageNumber?: number | undefined;
    /** Result page size */
    pageResultQuantity?: number | undefined;
    /** Total found results */
    totalResultQuantity?: number | undefined;
}

export class QueryRewardsDTO implements IQueryRewardsDTO {
    onlyValid?: boolean | undefined;

    constructor(data?: IQueryRewardsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onlyValid = _data["onlyValid"];
        }
    }

    static fromJS(data: any): QueryRewardsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QueryRewardsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onlyValid"] = this.onlyValid;
        return data; 
    }
}

export interface IQueryRewardsDTO {
    onlyValid?: boolean | undefined;
}

export class RedeemSubventionRequestDTO implements IRedeemSubventionRequestDTO {
    files?: FileAttachmentDTO[] | undefined;
    iban?: string | undefined;
    rewardId?: number | undefined;

    constructor(data?: IRedeemSubventionRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files.push(FileAttachmentDTO.fromJS(item));
            }
            this.iban = _data["iban"];
            this.rewardId = _data["rewardId"];
        }
    }

    static fromJS(data: any): RedeemSubventionRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RedeemSubventionRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["iban"] = this.iban;
        data["rewardId"] = this.rewardId;
        return data; 
    }
}

export interface IRedeemSubventionRequestDTO {
    files?: FileAttachmentDTO[] | undefined;
    iban?: string | undefined;
    rewardId?: number | undefined;
}

export class RedemptionRequestDTO implements IRedemptionRequestDTO {
    activityDate?: moment.Moment | undefined;
    /** Date when the request was processed completely */
    completion?: moment.Moment | undefined;
    /** set for direct award */
    directRewardRequest?: DirectRewardRequestDTO | undefined;
    id?: number | undefined;
    /** set if it's a multiple reedamable activity */
    multipleRedeemableActivityDetail?: MultipleRedeemableActivityDetailDTO | undefined;
    rejectionReason?: RedemptionRequestDTORejectionReason | undefined;
    /** Current status of the redemption request. Posiible Values: Open, Locked, Accepted, Modified, Rejected */
    status?: string | undefined;
    /** Date when the request was submitted */
    submission?: moment.Moment | undefined;

    constructor(data?: IRedemptionRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityDate = _data["activityDate"] ? moment(_data["activityDate"].toString()) : <any>undefined;
            this.completion = _data["completion"] ? moment(_data["completion"].toString()) : <any>undefined;
            this.directRewardRequest = _data["directRewardRequest"] ? DirectRewardRequestDTO.fromJS(_data["directRewardRequest"]) : <any>undefined;
            this.id = _data["id"];
            this.multipleRedeemableActivityDetail = _data["multipleRedeemableActivityDetail"] ? MultipleRedeemableActivityDetailDTO.fromJS(_data["multipleRedeemableActivityDetail"]) : <any>undefined;
            this.rejectionReason = _data["rejectionReason"];
            this.status = _data["status"];
            this.submission = _data["submission"] ? moment(_data["submission"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RedemptionRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RedemptionRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityDate"] = this.activityDate ? this.activityDate.toISOString() : <any>undefined;
        data["completion"] = this.completion ? this.completion.toISOString() : <any>undefined;
        data["directRewardRequest"] = this.directRewardRequest ? this.directRewardRequest.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["multipleRedeemableActivityDetail"] = this.multipleRedeemableActivityDetail ? this.multipleRedeemableActivityDetail.toJSON() : <any>undefined;
        data["rejectionReason"] = this.rejectionReason;
        data["status"] = this.status;
        data["submission"] = this.submission ? this.submission.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IRedemptionRequestDTO {
    activityDate?: moment.Moment | undefined;
    /** Date when the request was processed completely */
    completion?: moment.Moment | undefined;
    /** set for direct award */
    directRewardRequest?: DirectRewardRequestDTO | undefined;
    id?: number | undefined;
    /** set if it's a multiple reedamable activity */
    multipleRedeemableActivityDetail?: MultipleRedeemableActivityDetailDTO | undefined;
    rejectionReason?: RedemptionRequestDTORejectionReason | undefined;
    /** Current status of the redemption request. Posiible Values: Open, Locked, Accepted, Modified, Rejected */
    status?: string | undefined;
    /** Date when the request was submitted */
    submission?: moment.Moment | undefined;
}

export class RegistrationFormRequestDTO implements IRegistrationFormRequestDTO {
    additionalInsured?: AdditionalInsuredRegistrationDTO[] | undefined;
    addressSupplement?: string | undefined;
    addressValidation?: boolean | undefined;
    advertisingConsentDate?: moment.Moment | undefined;
    birthdate?: moment.Moment | undefined;
    chequeBookDelivery?: RegistrationFormRequestDTOChequeBookDelivery | undefined;
    city?: string | undefined;
    countryCode?: string | undefined;
    dataUsageConsentDate?: moment.Moment | undefined;
    email?: string | undefined;
    firstname?: string | undefined;
    kvnr?: string | undefined;
    lastname?: string | undefined;
    mainCollectorDmdId?: number | undefined;
    mainCollectorKVNR?: string | undefined;
    mediaCode?: string | undefined;
    mobilePhone2FA?: string | undefined;
    namePrefix?: string | undefined;
    onlineAccessRequested?: boolean | undefined;
    phone1?: string | undefined;
    phone2?: string | undefined;
    registerAdditionalInsured?: boolean | undefined;
    salutation?: RegistrationFormRequestDTOSalutation | undefined;
    street?: string | undefined;
    streetNo?: string | undefined;
    taxNumber?: string | undefined;
    title?: string | undefined;
    zip?: string | undefined;

    constructor(data?: IRegistrationFormRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["additionalInsured"])) {
                this.additionalInsured = [] as any;
                for (let item of _data["additionalInsured"])
                    this.additionalInsured.push(AdditionalInsuredRegistrationDTO.fromJS(item));
            }
            this.addressSupplement = _data["addressSupplement"];
            this.addressValidation = _data["addressValidation"];
            this.advertisingConsentDate = _data["advertisingConsentDate"] ? moment(_data["advertisingConsentDate"].toString()) : <any>undefined;
            this.birthdate = _data["birthdate"] ? moment(_data["birthdate"].toString()) : <any>undefined;
            this.chequeBookDelivery = _data["chequeBookDelivery"];
            this.city = _data["city"];
            this.countryCode = _data["countryCode"];
            this.dataUsageConsentDate = _data["dataUsageConsentDate"] ? moment(_data["dataUsageConsentDate"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.firstname = _data["firstname"];
            this.kvnr = _data["kvnr"];
            this.lastname = _data["lastname"];
            this.mainCollectorDmdId = _data["mainCollectorDmdId"];
            this.mainCollectorKVNR = _data["mainCollectorKVNR"];
            this.mediaCode = _data["mediaCode"];
            this.mobilePhone2FA = _data["mobilePhone2FA"];
            this.namePrefix = _data["namePrefix"];
            this.onlineAccessRequested = _data["onlineAccessRequested"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.registerAdditionalInsured = _data["registerAdditionalInsured"];
            this.salutation = _data["salutation"];
            this.street = _data["street"];
            this.streetNo = _data["streetNo"];
            this.taxNumber = _data["taxNumber"];
            this.title = _data["title"];
            this.zip = _data["zip"];
        }
    }

    static fromJS(data: any): RegistrationFormRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationFormRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.additionalInsured)) {
            data["additionalInsured"] = [];
            for (let item of this.additionalInsured)
                data["additionalInsured"].push(item.toJSON());
        }
        data["addressSupplement"] = this.addressSupplement;
        data["addressValidation"] = this.addressValidation;
        data["advertisingConsentDate"] = this.advertisingConsentDate ? this.advertisingConsentDate.toISOString() : <any>undefined;
        data["birthdate"] = this.birthdate ? this.birthdate.toISOString() : <any>undefined;
        data["chequeBookDelivery"] = this.chequeBookDelivery;
        data["city"] = this.city;
        data["countryCode"] = this.countryCode;
        data["dataUsageConsentDate"] = this.dataUsageConsentDate ? this.dataUsageConsentDate.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["firstname"] = this.firstname;
        data["kvnr"] = this.kvnr;
        data["lastname"] = this.lastname;
        data["mainCollectorDmdId"] = this.mainCollectorDmdId;
        data["mainCollectorKVNR"] = this.mainCollectorKVNR;
        data["mediaCode"] = this.mediaCode;
        data["mobilePhone2FA"] = this.mobilePhone2FA;
        data["namePrefix"] = this.namePrefix;
        data["onlineAccessRequested"] = this.onlineAccessRequested;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["registerAdditionalInsured"] = this.registerAdditionalInsured;
        data["salutation"] = this.salutation;
        data["street"] = this.street;
        data["streetNo"] = this.streetNo;
        data["taxNumber"] = this.taxNumber;
        data["title"] = this.title;
        data["zip"] = this.zip;
        return data; 
    }
}

export interface IRegistrationFormRequestDTO {
    additionalInsured?: AdditionalInsuredRegistrationDTO[] | undefined;
    addressSupplement?: string | undefined;
    addressValidation?: boolean | undefined;
    advertisingConsentDate?: moment.Moment | undefined;
    birthdate?: moment.Moment | undefined;
    chequeBookDelivery?: RegistrationFormRequestDTOChequeBookDelivery | undefined;
    city?: string | undefined;
    countryCode?: string | undefined;
    dataUsageConsentDate?: moment.Moment | undefined;
    email?: string | undefined;
    firstname?: string | undefined;
    kvnr?: string | undefined;
    lastname?: string | undefined;
    mainCollectorDmdId?: number | undefined;
    mainCollectorKVNR?: string | undefined;
    mediaCode?: string | undefined;
    mobilePhone2FA?: string | undefined;
    namePrefix?: string | undefined;
    onlineAccessRequested?: boolean | undefined;
    phone1?: string | undefined;
    phone2?: string | undefined;
    registerAdditionalInsured?: boolean | undefined;
    salutation?: RegistrationFormRequestDTOSalutation | undefined;
    street?: string | undefined;
    streetNo?: string | undefined;
    taxNumber?: string | undefined;
    title?: string | undefined;
    zip?: string | undefined;
}

export class RegistrationFormResultDTO implements IRegistrationFormResultDTO {
    addressSuggestDTOList?: AddressDTO[] | undefined;
    addressValidationResult?: RegistrationFormResultDTOAddressValidationResult | undefined;
    dmdId?: number | undefined;
    participantId?: number | undefined;

    constructor(data?: IRegistrationFormResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["addressSuggestDTOList"])) {
                this.addressSuggestDTOList = [] as any;
                for (let item of _data["addressSuggestDTOList"])
                    this.addressSuggestDTOList.push(AddressDTO.fromJS(item));
            }
            this.addressValidationResult = _data["addressValidationResult"];
            this.dmdId = _data["dmdId"];
            this.participantId = _data["participantId"];
        }
    }

    static fromJS(data: any): RegistrationFormResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationFormResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.addressSuggestDTOList)) {
            data["addressSuggestDTOList"] = [];
            for (let item of this.addressSuggestDTOList)
                data["addressSuggestDTOList"].push(item.toJSON());
        }
        data["addressValidationResult"] = this.addressValidationResult;
        data["dmdId"] = this.dmdId;
        data["participantId"] = this.participantId;
        return data; 
    }
}

export interface IRegistrationFormResultDTO {
    addressSuggestDTOList?: AddressDTO[] | undefined;
    addressValidationResult?: RegistrationFormResultDTOAddressValidationResult | undefined;
    dmdId?: number | undefined;
    participantId?: number | undefined;
}

export class RelatedCommunityMemberDTO implements IRelatedCommunityMemberDTO {
    firstname?: string | undefined;
    kvnr?: string | undefined;
    lastname?: string | undefined;
    mainCollector?: boolean | undefined;
    membership?: MembershipAokDTO | undefined;
    namePrefix?: string | undefined;
    salutation?: RelatedCommunityMemberDTOSalutation | undefined;
    title?: string | undefined;

    constructor(data?: IRelatedCommunityMemberDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstname = _data["firstname"];
            this.kvnr = _data["kvnr"];
            this.lastname = _data["lastname"];
            this.mainCollector = _data["mainCollector"];
            this.membership = _data["membership"] ? MembershipAokDTO.fromJS(_data["membership"]) : <any>undefined;
            this.namePrefix = _data["namePrefix"];
            this.salutation = _data["salutation"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): RelatedCommunityMemberDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RelatedCommunityMemberDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstname"] = this.firstname;
        data["kvnr"] = this.kvnr;
        data["lastname"] = this.lastname;
        data["mainCollector"] = this.mainCollector;
        data["membership"] = this.membership ? this.membership.toJSON() : <any>undefined;
        data["namePrefix"] = this.namePrefix;
        data["salutation"] = this.salutation;
        data["title"] = this.title;
        return data; 
    }
}

export interface IRelatedCommunityMemberDTO {
    firstname?: string | undefined;
    kvnr?: string | undefined;
    lastname?: string | undefined;
    mainCollector?: boolean | undefined;
    membership?: MembershipAokDTO | undefined;
    namePrefix?: string | undefined;
    salutation?: RelatedCommunityMemberDTOSalutation | undefined;
    title?: string | undefined;
}

export class RequestDownloadChequeBookDTO implements IRequestDownloadChequeBookDTO {
    activityIds?: number[] | undefined;

    constructor(data?: IRequestDownloadChequeBookDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["activityIds"])) {
                this.activityIds = [] as any;
                for (let item of _data["activityIds"])
                    this.activityIds.push(item);
            }
        }
    }

    static fromJS(data: any): RequestDownloadChequeBookDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RequestDownloadChequeBookDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activityIds)) {
            data["activityIds"] = [];
            for (let item of this.activityIds)
                data["activityIds"].push(item);
        }
        return data; 
    }
}

export interface IRequestDownloadChequeBookDTO {
    activityIds?: number[] | undefined;
}

/** Loyalty Program Resource Reference DTO. */
export class ResourceReferenceDTO implements IResourceReferenceDTO {
    /** ResourceReference alternativeText */
    alternativeText?: string | undefined;
    /** ResourceReference filename */
    filename?: string | undefined;
    /** ResourceReference ID */
    id?: number | undefined;

    constructor(data?: IResourceReferenceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alternativeText = _data["alternativeText"];
            this.filename = _data["filename"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ResourceReferenceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceReferenceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alternativeText"] = this.alternativeText;
        data["filename"] = this.filename;
        data["id"] = this.id;
        return data; 
    }
}

/** Loyalty Program Resource Reference DTO. */
export interface IResourceReferenceDTO {
    /** ResourceReference alternativeText */
    alternativeText?: string | undefined;
    /** ResourceReference filename */
    filename?: string | undefined;
    /** ResourceReference ID */
    id?: number | undefined;
}

/** Reward Group DTO. */
export class RewardGroupDTO implements IRewardGroupDTO {
    /** formatted description */
    formattedDescription?: string | undefined;
    /** group */
    group?: RewardGroupDTOGroup | undefined;
    /** key */
    key?: string | undefined;
    /** resources */
    resources?: ResourceReferenceDTO[] | undefined;
    /** short description */
    shortDescription?: string | undefined;
    /** thumbnail */
    thumbnail?: ResourceReferenceDTO | undefined;

    constructor(data?: IRewardGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formattedDescription = _data["formattedDescription"];
            this.group = _data["group"];
            this.key = _data["key"];
            if (Array.isArray(_data["resources"])) {
                this.resources = [] as any;
                for (let item of _data["resources"])
                    this.resources.push(ResourceReferenceDTO.fromJS(item));
            }
            this.shortDescription = _data["shortDescription"];
            this.thumbnail = _data["thumbnail"] ? ResourceReferenceDTO.fromJS(_data["thumbnail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RewardGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RewardGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formattedDescription"] = this.formattedDescription;
        data["group"] = this.group;
        data["key"] = this.key;
        if (Array.isArray(this.resources)) {
            data["resources"] = [];
            for (let item of this.resources)
                data["resources"].push(item.toJSON());
        }
        data["shortDescription"] = this.shortDescription;
        data["thumbnail"] = this.thumbnail ? this.thumbnail.toJSON() : <any>undefined;
        return data; 
    }
}

/** Reward Group DTO. */
export interface IRewardGroupDTO {
    /** formatted description */
    formattedDescription?: string | undefined;
    /** group */
    group?: RewardGroupDTOGroup | undefined;
    /** key */
    key?: string | undefined;
    /** resources */
    resources?: ResourceReferenceDTO[] | undefined;
    /** short description */
    shortDescription?: string | undefined;
    /** thumbnail */
    thumbnail?: ResourceReferenceDTO | undefined;
}

export class TenantDTO implements ITenantDTO {
    ftamid?: string | undefined;
    id?: number | undefined;
    insuranceId?: string | undefined;
    key?: string | undefined;
    mediaCodes?: MediaCodeDTO[] | undefined;
    name?: string | undefined;
    programs?: LoyaltyProgramDTO[] | undefined;
    tenantId?: string | undefined;

    constructor(data?: ITenantDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ftamid = _data["ftamid"];
            this.id = _data["id"];
            this.insuranceId = _data["insuranceId"];
            this.key = _data["key"];
            if (Array.isArray(_data["mediaCodes"])) {
                this.mediaCodes = [] as any;
                for (let item of _data["mediaCodes"])
                    this.mediaCodes.push(MediaCodeDTO.fromJS(item));
            }
            this.name = _data["name"];
            if (Array.isArray(_data["programs"])) {
                this.programs = [] as any;
                for (let item of _data["programs"])
                    this.programs.push(LoyaltyProgramDTO.fromJS(item));
            }
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): TenantDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ftamid"] = this.ftamid;
        data["id"] = this.id;
        data["insuranceId"] = this.insuranceId;
        data["key"] = this.key;
        if (Array.isArray(this.mediaCodes)) {
            data["mediaCodes"] = [];
            for (let item of this.mediaCodes)
                data["mediaCodes"].push(item.toJSON());
        }
        data["name"] = this.name;
        if (Array.isArray(this.programs)) {
            data["programs"] = [];
            for (let item of this.programs)
                data["programs"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface ITenantDTO {
    ftamid?: string | undefined;
    id?: number | undefined;
    insuranceId?: string | undefined;
    key?: string | undefined;
    mediaCodes?: MediaCodeDTO[] | undefined;
    name?: string | undefined;
    programs?: LoyaltyProgramDTO[] | undefined;
    tenantId?: string | undefined;
}

export class UpdateChequebookDeliveryDTO implements IUpdateChequebookDeliveryDTO {
    chequebookDelivery?: string | undefined;
    email?: string | undefined;

    constructor(data?: IUpdateChequebookDeliveryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chequebookDelivery = _data["chequebookDelivery"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UpdateChequebookDeliveryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateChequebookDeliveryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chequebookDelivery"] = this.chequebookDelivery;
        data["email"] = this.email;
        return data; 
    }
}

export interface IUpdateChequebookDeliveryDTO {
    chequebookDelivery?: string | undefined;
    email?: string | undefined;
}

export enum AokErrotDTOCodeICode {
    UNKNOWN = <any>"UNKNOWN",
    DEFAULT = <any>"DEFAULT",
    DATABASE_DOWN = <any>"DATABASE_DOWN",
    PARTICIPANT_NOT_FOUND = <any>"PARTICIPANT_NOT_FOUND",
    MEMBERSHIP_NOT_FOUND = <any>"MEMBERSHIP_NOT_FOUND",
    LOYALTY_PROGRAM_NOT_FOUND = <any>"LOYALTY_PROGRAM_NOT_FOUND",
    REWARD_NOT_FOUND = <any>"REWARD_NOT_FOUND",
    VALIDATION_ERROR = <any>"VALIDATION_ERROR",
    ORDER_CHECK_FAILED = <any>"ORDER_CHECK_FAILED",
    NOT_ALLOWED = <any>"NOT_ALLOWED",
    NEGATIVE_BALANCE = <any>"NEGATIVE_BALANCE",
    NOT_SUPPORTED = <any>"NOT_SUPPORTED",
    TOO_LARGE = <any>"TOO_LARGE",
    OPTIMISTIC_LOCK = <any>"OPTIMISTIC_LOCK",
    DATA_INTEGRITY_VIOLATED = <any>"DATA_INTEGRITY_VIOLATED",
    SENDER_NOT_FOUND = <any>"SENDER_NOT_FOUND",
    CONFIGURATION_NOT_FOUND = <any>"CONFIGURATION_NOT_FOUND",
    ACTIVITY_PROTOTYPE_NOT_FOUND = <any>"ACTIVITY_PROTOTYPE_NOT_FOUND",
    NO_ENVELOPE_TO_PROCESS = <any>"NO_ENVELOPE_TO_PROCESS",
    ACTIVITY_NOT_FOUND = <any>"ACTIVITY_NOT_FOUND",
    NOT_PART_OF_CHEQUEBOOK = <any>"NOT_PART_OF_CHEQUEBOOK",
    CHEQUEBOOK_NOT_FOUND = <any>"CHEQUEBOOK_NOT_FOUND",
    RECEIPT_REFERENCE_NOT_FOUND = <any>"RECEIPT_REFERENCE_NOT_FOUND",
    ORDER_NOT_FOUND = <any>"ORDER_NOT_FOUND",
    ORDER_ITEM_NOT_FOUND = <any>"ORDER_ITEM_NOT_FOUND",
    DOCUMENT_TEMPLATE_NOT_FOUND = <any>"DOCUMENT_TEMPLATE_NOT_FOUND",
    POSTING_NOT_FOUND = <any>"POSTING_NOT_FOUND",
    HISTORY_ENTRY_NOT_FOUND = <any>"HISTORY_ENTRY_NOT_FOUND",
    INSURANT_DATA_REQUEST_ERROR = <any>"INSURANT_DATA_REQUEST_ERROR",
    RESERVED_ORDER_ALREADY_EXISTS = <any>"RESERVED_ORDER_ALREADY_EXISTS",
    ORDER_ITEM_WRONG_STATE = <any>"ORDER_ITEM_WRONG_STATE",
    ITEM_NOT_RETURNABLE = <any>"ITEM_NOT_RETURNABLE",
    ONLY_ONE_TEMPLATE_ALLOWED = <any>"ONLY_ONE_TEMPLATE_ALLOWED",
    SERVICE_NOT_AVAILABLE = <any>"SERVICE_NOT_AVAILABLE",
    ILLEGAL_STATE = <any>"ILLEGAL_STATE",
    ACCOUNT_LOCKED = <any>"ACCOUNT_LOCKED",
    WRONG_TYPE = <any>"WRONG_TYPE",
    REDEMPTION_NOT_ALLOWED = <any>"REDEMPTION_NOT_ALLOWED",
    INVALID_CRITERIA = <any>"INVALID_CRITERIA",
    PENDING_REDEMPTION = <any>"PENDING_REDEMPTION",
    PROTOTYPE_IS_REFERENCED = <any>"PROTOTYPE_IS_REFERENCED",
    PARTICIPANT_NOT_WHITELISTED = <any>"PARTICIPANT_NOT_WHITELISTED",
    RECEIVER_NOT_FOUND = <any>"RECEIVER_NOT_FOUND",
    RECEIVER_STATUS_ERROR = <any>"RECEIVER_STATUS_ERROR",
    DIFFERENT_MAIN_INSURED = <any>"DIFFERENT_MAIN_INSURED",
    ADDITIONAL_INSURED_TOO_OLD = <any>"ADDITIONAL_INSURED_TOO_OLD",
    WRONG_LOYALTYPROGRAM = <any>"WRONG_LOYALTYPROGRAM",
    ALREADY_REDEEMED = <any>"ALREADY_REDEEMED",
    SELECTIVE_TARIFF_MEMBERSHIP = <any>"SELECTIVE_TARIFF_MEMBERSHIP",
    ACTIVITY_NOT_REDEEMED = <any>"ACTIVITY_NOT_REDEEMED",
    REDMPTION_REQUEST_NOT_FOUND = <any>"REDMPTION_REQUEST_NOT_FOUND",
    REDEMPTION_BELONGS_TO_OTHER_ACTIVITY = <any>"REDEMPTION_BELONGS_TO_OTHER_ACTIVITY",
    MISSING_PAGES = <any>"MISSING_PAGES",
    UNKNOWN_PAGES = <any>"UNKNOWN_PAGES",
    REGISTRATION_NOT_ALLOWED = <any>"REGISTRATION_NOT_ALLOWED",
    CANCEL_ANNOUNCED = <any>"CANCEL_ANNOUNCED",
    REWARD_NOT_VALID = <any>"REWARD_NOT_VALID",
    DUPLICATE_FOLLOW_UP = <any>"DUPLICATE_FOLLOW_UP",
    FOLLOW_UP_NOT_FOUND = <any>"FOLLOW_UP_NOT_FOUND",
    KVNR_NOT_FOUND = <any>"KVNR_NOT_FOUND",
    TENANT_NOT_FOUND = <any>"TENANT_NOT_FOUND",
    TENANT_NOT_SET = <any>"TENANT_NOT_SET",
    NO_FAQS_FOUND = <any>"NO_FAQS_FOUND",
    NO_NEWS_FOUND = <any>"NO_NEWS_FOUND",
    NO_ACTIVITY_PROTOTYPES_FOUND = <any>"NO_ACTIVITY_PROTOTYPES_FOUND",
    NEWS_RECORD_NOT_FOUND = <any>"NEWS_RECORD_NOT_FOUND",
    ADDRESS_VALIDATION_NOT_AVAILABLE = <any>"ADDRESS_VALIDATION_NOT_AVAILABLE",
    RESOURCE_NOT_FOUND = <any>"RESOURCE_NOT_FOUND",
    NO_REWARD_GROUPS_FOUND = <any>"NO_REWARD_GROUPS_FOUND",
    NO_REWARDS_FOUND = <any>"NO_REWARDS_FOUND",
    BAD_SYNC_REWARD = <any>"BAD_SYNC_REWARD",
    REWARD_IN_USE = <any>"REWARD_IN_USE",
    PRECONDITION_VIOLATION = <any>"PRECONDITION_VIOLATION",
    ACTIVITY_ALREADY_REDEEMED = <any>"ACTIVITY_ALREADY_REDEEMED",
    INVALID_MEDIA_CODE = <any>"INVALID_MEDIA_CODE",
    TOO_MANY_FELLOW_COLLECTORS = <any>"TOO_MANY_FELLOW_COLLECTORS",
    MAX_POINTS_COLLECTED_ALREADY = <any>"MAX_POINTS_COLLECTED_ALREADY",
    MAIN_COLLECTOR_NOT_FOUND = <any>"MAIN_COLLECTOR_NOT_FOUND",
    KVNR_ALREADY_EXISTS = <any>"KVNR_ALREADY_EXISTS",
    ACCOUNT_HAS_ONLY_ONE_MEMBERSHIP = <any>"ACCOUNT_HAS_ONLY_ONE_MEMBERSHIP",
    MEMBERSHIP_IS_MAINCOLLECTOR = <any>"MEMBERSHIP_IS_MAINCOLLECTOR",
    DUPLICATE_ARTICLE = <any>"DUPLICATE_ARTICLE",
    CHEQUEBOOK_ALREADY_RESEND = <any>"CHEQUEBOOK_ALREADY_RESEND",
    POSTING_ALREADY_CLEARED = <any>"POSTING_ALREADY_CLEARED",
    ACTIVITY_TOO_OLD = <any>"ACTIVITY_TOO_OLD",
    PARTICIPANT_LETTER_NOT_FOUND = <any>"PARTICIPANT_LETTER_NOT_FOUND",
    HISTORY_DETAIL_NOT_FOUND = <any>"HISTORY_DETAIL_NOT_FOUND",
    INVALID_YEAR = <any>"INVALID_YEAR",
}

export enum AokErrotDTOCodeICodeAok {
    TenantNotFound = <any>"TenantNotFound",
    AdditionalInsuredInvalid = <any>"AdditionalInsuredInvalid",
    MainCollectorNotActive = <any>"MainCollectorNotActive",
    SYNC_IN_PROCESS = <any>"SYNC_IN_PROCESS",
    SYNC_NOT_IN_PROCESS = <any>"SYNC_NOT_IN_PROCESS",
    OPTIN_TOKEN_NOTFOUND = <any>"OPTIN_TOKEN_NOTFOUND",
    OPTIN_TOKEN_EXPIRED = <any>"OPTIN_TOKEN_EXPIRED",
    OPTIN_TOKEN_ALREADY_CONFIRMED = <any>"OPTIN_TOKEN_ALREADY_CONFIRMED",
    PARTICIPANT_NOT_ACTIVE = <any>"PARTICIPANT_NOT_ACTIVE",
    PARTICIPANT_IS_PMV = <any>"PARTICIPANT_IS_PMV",
    ONLINE_ACCESS_ALREADY_EXISTS = <any>"ONLINE_ACCESS_ALREADY_EXISTS",
    KVNR_ALREADY_IN_USE = <any>"KVNR_ALREADY_IN_USE",
    COULD_NOT_CHANGE_PASSWORD = <any>"COULD_NOT_CHANGE_PASSWORD",
    INCORRECT_PASSWORD = <any>"INCORRECT_PASSWORD",
    EMAIL_NOT_UNIQUE = <any>"EMAIL_NOT_UNIQUE",
    NOT_PROSPECTIVE = <any>"NOT_PROSPECTIVE",
    ONLINE_ACCESS_NOT_EXISTS = <any>"ONLINE_ACCESS_NOT_EXISTS",
    ORDERITEM_IN_WRONG_STATE = <any>"ORDERITEM_IN_WRONG_STATE",
    TARIFF_NOT_FOUND = <any>"TARIFF_NOT_FOUND",
    PARTICIPANT_NOT_PROSPECTIVE_NOR_PARTICIPANT = <any>"PARTICIPANT_NOT_PROSPECTIVE_NOR_PARTICIPANT",
    FELLOW_IS_PROSPECTIVE_OR_PARTICIPANT = <any>"FELLOW_IS_PROSPECTIVE_OR_PARTICIPANT",
}

export enum DeliveryAddressDTOSalutation {
    MALE = <any>"MALE",
    FEMALE = <any>"FEMALE",
    DIVERSE = <any>"DIVERSE",
}

export enum ErrorDTOAokSubcodeISubcode {
    InsuranceEnded = <any>"InsuranceEnded",
    InsuranceNotStarted = <any>"InsuranceNotStarted",
    NoKvnr = <any>"NoKvnr",
    DuplicateInsurant = <any>"DuplicateInsurant",
    InsurantNotFound = <any>"InsurantNotFound",
    KVNRDoesNotMatch = <any>"KVNRDoesNotMatch",
    TechnicalError = <any>"TechnicalError",
    MandatoryResultFieldsMissing = <any>"MandatoryResultFieldsMissing",
    AlreadyParticipant = <any>"AlreadyParticipant",
    WrongParticipantStatus = <any>"WrongParticipantStatus",
    NotEnoughClaimsForReward = <any>"NotEnoughClaimsForReward",
    NotEnoughPoints = <any>"NotEnoughPoints",
    DuplicateSubvention = <any>"DuplicateSubvention",
    GiftToMyself = <any>"GiftToMyself",
    DeliveryAddressInvalid = <any>"DeliveryAddressInvalid",
    CancellationAnounced = <any>"CancellationAnounced",
    ONLY_AS_DIRECT_REWARD_ORDERABLE = <any>"ONLY_AS_DIRECT_REWARD_ORDERABLE",
    PostingTooOld = <any>"PostingTooOld",
    UNKNOWN = <any>"UNKNOWN",
}

export enum ErrorDTOAokSubcodeISubcodeAok {
    None = <any>"None",
}

export enum ExtendedRewardDTOCategory {
    Kids = <any>"Kids",
    Teens = <any>"Teens",
    Adults = <any>"Adults",
}

export enum ExtendedRewardDTOGroup {
    Sports = <any>"Sports",
    Health = <any>"Health",
    Nutrition = <any>"Nutrition",
    Electronics = <any>"Electronics",
    Fun = <any>"Fun",
    Donation = <any>"Donation",
    Money = <any>"Money",
    Subvention = <any>"Subvention",
    Family = <any>"Family",
    BayernSpezial = <any>"BayernSpezial",
    PromotionSpezial = <any>"PromotionSpezial",
    FamilyBonus = <any>"FamilyBonus",
    RegionalPromotion = <any>"RegionalPromotion",
}

export enum ExtendedRewardDTOType {
    PHYSICAL = <any>"PHYSICAL",
    MONEY = <any>"MONEY",
    COUPON = <any>"COUPON",
    DONATION = <any>"DONATION",
    GIFT = <any>"GIFT",
    SUBVENTION = <any>"SUBVENTION",
    MONEY_INTERNATIONAL = <any>"MONEY_INTERNATIONAL",
}

export enum FeedbackDTOSalutation {
    MALE = <any>"MALE",
    FEMALE = <any>"FEMALE",
    DIVERSE = <any>"DIVERSE",
}

export enum MediaCodeDTOStatus {
    DELETED = <any>"DELETED",
    VALID = <any>"VALID",
    INVALID = <any>"INVALID",
}

export enum MembershipAokDTOChequebookDelivery {
    ONLINE = <any>"ONLINE",
    LETTER = <any>"LETTER",
    NONE = <any>"NONE",
}

export enum OrderItemDTOStatus {
    CREATED = <any>"CREATED",
    DELIVERED = <any>"DELIVERED",
    RETURNED = <any>"RETURNED",
    CANCELLED = <any>"CANCELLED",
    RESERVED = <any>"RESERVED",
    REVIEW = <any>"REVIEW",
    PARTIALLY_RETURNED = <any>"PARTIALLY_RETURNED",
    TRANSFERRED = <any>"TRANSFERRED",
    REJECTED = <any>"REJECTED",
}

export enum OrderItemDTOType {
    PHYSICAL = <any>"PHYSICAL",
    MONEY = <any>"MONEY",
    COUPON = <any>"COUPON",
    DONATION = <any>"DONATION",
    GIFT = <any>"GIFT",
    SUBVENTION = <any>"SUBVENTION",
    MONEY_INTERNATIONAL = <any>"MONEY_INTERNATIONAL",
}

export enum RedemptionRequestDTORejectionReason {
    ACTIVITY_TOO_OLD = <any>"ACTIVITY_TOO_OLD",
    ACTIVITY_ALREADY_REDEEMED = <any>"ACTIVITY_ALREADY_REDEEMED",
    ACTIVITY_NOT_COMPLETED = <any>"ACTIVITY_NOT_COMPLETED",
    AUTHENTICATION_MISSING = <any>"AUTHENTICATION_MISSING",
    ACTIVITY_PERIOD_NOT_READABLE = <any>"ACTIVITY_PERIOD_NOT_READABLE",
    NO_ACTIVE_MEMBERSHIP = <any>"NO_ACTIVE_MEMBERSHIP",
    NO_ACTIVITY_BOOKED = <any>"NO_ACTIVITY_BOOKED",
    WRONG_ACCOUNT = <any>"WRONG_ACCOUNT",
    JOB_RELATED_ACTIVITY = <any>"JOB_RELATED_ACTIVITY",
    NO_PREVENTION = <any>"NO_PREVENTION",
    VERIFICATION_INVALID = <any>"VERIFICATION_INVALID",
    IDENTIFICATION_MISSING = <any>"IDENTIFICATION_MISSING",
    DIFFERENT_YEAR_POSTED = <any>"DIFFERENT_YEAR_POSTED",
    DIFFERENT_ACTIVITY_BOOKED = <any>"DIFFERENT_ACTIVITY_BOOKED",
    SPLIT = <any>"SPLIT",
    ACTIVITY_NOT_AVAILABLE = <any>"ACTIVITY_NOT_AVAILABLE",
    VERIFICATION_NOT_READABLE = <any>"VERIFICATION_NOT_READABLE",
    NO_ADULT = <any>"NO_ADULT",
    SELECTIVE_TARIFF_ACTIVE = <any>"SELECTIVE_TARIFF_ACTIVE",
    CANCELLATION_ANNOUNCED = <any>"CANCELLATION_ANNOUNCED",
    ADDITIONAL_INFOS = <any>"ADDITIONAL_INFOS",
    WRONG_ACTIVITY = <any>"WRONG_ACTIVITY",
    WRONG_VERIFICATION = <any>"WRONG_VERIFICATION",
    WRONG_CHEQUE_BOOK_YEAR = <any>"WRONG_CHEQUE_BOOK_YEAR",
    OTHER = <any>"OTHER",
    INVALID_VERIFICATION = <any>"INVALID_VERIFICATION",
    VERIFICATION_INSUFFICIENT = <any>"VERIFICATION_INSUFFICIENT",
    IBAN_NOT_AVAILABLE = <any>"IBAN_NOT_AVAILABLE",
    VALUE_NOT_MATCHING_SPEC = <any>"VALUE_NOT_MATCHING_SPEC",
    ACTIVITY_NAME_NOT_READABLE = <any>"ACTIVITY_NAME_NOT_READABLE",
    MULTIPLE_VACCINATION_ONLY_ONCE = <any>"MULTIPLE_VACCINATION_ONLY_ONCE",
    ACTIVITY_NOT_INVOICED = <any>"ACTIVITY_NOT_INVOICED",
    ACTIVITY_IN_PERIOD_NOT_AVAILABLE = <any>"ACTIVITY_IN_PERIOD_NOT_AVAILABLE",
    VERIFICATION_IS_NOT_READABLE = <any>"VERIFICATION_IS_NOT_READABLE",
    NO_FITNESS_TRACKER = <any>"NO_FITNESS_TRACKER",
    DOCTOR_CONFIRMATION_NEEDED = <any>"DOCTOR_CONFIRMATION_NEEDED",
    MEDICAL_REFERRAL_INSUFFICIENT = <any>"MEDICAL_REFERRAL_INSUFFICIENT",
    NO_DENTAL_CHECKUP = <any>"NO_DENTAL_CHECKUP",
    NO_VACCINATION_NAME = <any>"NO_VACCINATION_NAME",
    NO_TRAINER_LICENCE = <any>"NO_TRAINER_LICENCE",
    CERTIFICATE_NEEDED = <any>"CERTIFICATE_NEEDED",
    ACTIVITY_NO_AMBLYOPIA_SCREENING = <any>"ACTIVITY_NO_AMBLYOPIA_SCREENING",
}

export enum RegistrationFormRequestDTOChequeBookDelivery {
    ONLINE = <any>"ONLINE",
    LETTER = <any>"LETTER",
    NONE = <any>"NONE",
}

export enum RegistrationFormRequestDTOSalutation {
    MALE = <any>"MALE",
    FEMALE = <any>"FEMALE",
    DIVERSE = <any>"DIVERSE",
}

export enum RegistrationFormResultDTOAddressValidationResult {
    ADDRESS_OK = <any>"ADDRESS_OK",
    ADDRESS_CORRECTED = <any>"ADDRESS_CORRECTED",
    ADDRESS_AMBIGUOUS = <any>"ADDRESS_AMBIGUOUS",
    ADDRESS_NOT_OK = <any>"ADDRESS_NOT_OK",
}

export enum RelatedCommunityMemberDTOSalutation {
    MALE = <any>"MALE",
    FEMALE = <any>"FEMALE",
    DIVERSE = <any>"DIVERSE",
}

export enum RewardGroupDTOGroup {
    Sports = <any>"Sports",
    Health = <any>"Health",
    Nutrition = <any>"Nutrition",
    Electronics = <any>"Electronics",
    Fun = <any>"Fun",
    Donation = <any>"Donation",
    Money = <any>"Money",
    Subvention = <any>"Subvention",
    Family = <any>"Family",
    BayernSpezial = <any>"BayernSpezial",
    PromotionSpezial = <any>"PromotionSpezial",
    FamilyBonus = <any>"FamilyBonus",
    RegionalPromotion = <any>"RegionalPromotion",
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}